import { Config, Listings } from 'containers/AppContainer/typings';
import {
  Expertise,
  JudgementADDDocumentType,
  JudgementOnMeritsVictim,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import _, {
  cloneDeep,
  difference,
  get,
  isArray,
  isEmpty,
  isNil,
  isNull,
  uniq,
  values,
} from 'lodash';
import moment from 'moment';
import {
  ICivilJudgement,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import {
  getVictimAge,
  getVictimRevenu,
  getVictimKey,
  resolveExpertiseValue,
} from 'containers/CourtManagerLegalProceedings/ExpertReport/utils';
import { EXPERTISE_MEDICAL_ID } from 'components/DesignationLetter/constants';
import { EXPERTISE_ACCOUNTING_ID } from 'containers/ExpertExpertise/ConcernedExpertise/constants';

import { getValueByCode } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import {
  ICorrectionalJudgementContestation,
  IExpertises,
  IJudgementContestation,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/typings';
import {
  CIVIL_JUDGEMENT,
  CIVIL_JUDGEMENT_ACCOUNTING_EXPERTISE,
  CIVIL_JUDGEMENT_TYPES,
  CIVIL_JUDGEMENT_VICTIM_FIELDS,
  COMPTABLE_EXPERTISE_ID,
  DEFAULT_RC_AMOUNT,
  JUDGEMENT_EXPERTISE_TYPES,
  JUDGEMENT_ON_MERITS_CIVIL_JUDGEMENT,
  JUDGEMENT_ON_MERITS_CORRECTIONAL_JUDGEMENT_CONTESTATION,
  MAX_ACCOUNTING_EXPERTISE_AMOUNT,
  MAX_IPP_RATE,
  MAX_PROVISION,
  MEDICAL_EXPERTISE_ID,
  MODE_TYPES,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import {
  BENEFICIARY,
  EXPERTISES,
  JUDGEMENT_ON_MERITS_VICTIM,
  PROCEDURE_STATUSES,
  PROCEDURE_STEPS,
  VICTIM_EXPERTISE_FIELDS,
} from 'containers/data-structure';
import { Beneficiary, Victim } from 'containers/PreOpeningPage/typings';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import { getJudgementAddDocuments } from 'containers/LawyerLegalProceedingsPage/utils';
import { INJURY_POST_KEY } from 'containers/LawyerLegalProceedingsPage/constants';
import {
  STATUS_PENDING,
  STATUS_REJECTED,
} from 'containers/LawyerFeeNote/constants';
import { MODE } from 'containers/CourtManagerLegalProceedings/ExpertReport/constants';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { validationCourtFileNumber } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/utils';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import {
  CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
  INCIDENT_TYPE,
} from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/constants';
import {
  EMPTY_CIVIL_JUDGEMENT,
  FEES,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/data-structure';
import { shouldValidateDesceasedVictim } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/form-validation';
import {
  areAllVictimsInCivjvmRecap,
  areAllVictimsInCivjvmAdd,
  isJomAssociatedVictimsIncluded,
  reasonWithoutCompensationConditions,
  checkVictimExistanceCivilPartyById,
  getCivilJudgementByVictimId,
  getResponsabilityShare,
  getRateItt,
} from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/utils';
import {
  getSubstantiveWithoutCompensation,
  isCivilJudgementVictimSubstantive,
  isNextOfKinsSubstantive,
  isNextOfKinsWithFormRejection,
} from 'containers/CourtManagerLegalProceedings/AppealOnMerits/utils';
import { VictimType } from 'typings/globalTypes';
import { GLOBAL_STATUS } from 'services/constants';
import { getTheLatestEvaluationObject } from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate/utils';

export const shouldDisplayExpertiseType = (
  expertiseId: string,
  judgementAddDocExpertises: Expertise[],
) => {
  return judgementAddDocExpertises.find(exp => {
    return expertiseId === String(exp.expertiseId);
  });
};

export const getExpertisejudgementAddDocId = (
  id: any,
  expertiseId: string,
  judgementAddDocExpertises: Expertise[],
  judgementAddAppeal: any,
) => {
  let expertiseJudgementAddDocumentId;

  const expertises = isEmpty(judgementAddDocExpertises)
    ? get(judgementAddAppeal, 'judgementAddDocuments.[0].expertises', [])
    : judgementAddDocExpertises;

  expertises.forEach((el: Expertise) => {
    const victim = get(el, 'victims', []).find((victim: VictimType) => {
      return String(el.expertiseId) === expertiseId && victim.id === Number(id);
    });
    if (victim) {
      expertiseJudgementAddDocumentId = el.expertiseJudgementAddDocumentId;
    }
    const vehicule = get(el, 'vehicules', []).find((vehicule: any) => {
      return (
        String(el.expertiseId) === expertiseId && vehicule.id === Number(id)
      );
    });
    if (vehicule) {
      expertiseJudgementAddDocumentId = el.expertiseJudgementAddDocumentId;
    }
  });
  return expertiseJudgementAddDocumentId;
};

export const getMotifs = (
  judgementOnMerits: JudgementOnMeritsType | {},
  reasons: Config[],
) => {
  let instruction = '';
  const reasonIds = get(
    judgementOnMerits,
    JUDGEMENT_ON_MERITS_CORRECTIONAL_JUDGEMENT_CONTESTATION,
    [],
  );
  return [
    ...reasonIds.map((el: ICorrectionalJudgementContestation) => {
      const id = el.judgementOnMeritsContestationReasonId;
      if (!instruction) instruction = el.instruction;
      return getValueByCode(id, reasons);
    }),
    instruction,
  ];
};

export const getCivilJudgementMotifs = (
  contestationReasons: IJudgementContestation[] | undefined,
  reasons: Config[],
) => {
  if (!contestationReasons) contestationReasons = [];
  let instruction = '';
  return [
    ...contestationReasons.map((el: IJudgementContestation) => {
      if (!instruction) instruction = el.instruction;
      return getValueByCode(el.judgementOnMeritsContestationReasonI, reasons);
    }),
    instruction,
  ];
};

export const isContested = (judgementOnMerits: JudgementOnMeritsType) => {
  return (
    !isEmpty(
      get(
        judgementOnMerits,
        JUDGEMENT_ON_MERITS_CORRECTIONAL_JUDGEMENT_CONTESTATION,
        [],
      ),
    ) || isCivilJudgementContested(judgementOnMerits)
  );
};

export const isCivilJudgementContested = (
  judgementOnMerits: JudgementOnMeritsType,
) => {
  let isContested = false;
  get(judgementOnMerits, JUDGEMENT_ON_MERITS_CIVIL_JUDGEMENT, []).forEach(
    (cj: ICivilJudgement) => {
      get(cj, 'civjmede', []).forEach(exp => {
        if (!isEmpty(exp.contest)) isContested = true;
      });
      if (isContested) return;
      get(cj, 'civjmece', []).forEach(exp => {
        if (!isEmpty(exp.contest)) isContested = true;
      });
      if (isContested) return;
      get(cj, 'civjacce', []).forEach(exp => {
        if (!isEmpty(exp.contest)) isContested = true;
      });
    },
  );
  return isContested;
};

export const getVictimKeys = (
  judgementADDDocuments: JudgementADDDocumentType[],
  isDeceased: boolean,
) => {
  let _judgementADDDocument = cloneDeep(judgementADDDocuments);
  return _judgementADDDocument
    .flatMap(add =>
      add.expertises.flatMap(expertise =>
        expertise.victims.flatMap(victim => {
          if (
            (isDeceased && victim.injuryPostKey === INJURY_POST_DECEASED) ||
            (!isDeceased && victim.injuryPostKey !== INJURY_POST_DECEASED)
          ) {
            return victim.victimKey;
          }
          return null;
        }),
      ),
    )
    .filter(item => !isEmpty(item));
};

export const rcAmountByVictim = (
  dahirAmounts: {
    evaluationDate: string;
    victimKey: string;
    rcAmount: number;
    responsibilityRate: number;
  }[],
  victimKey: string,
) => {
  const victimDahirAmounts = dahirAmounts.filter(
    el => el.victimKey === victimKey && el.rcAmount !== DEFAULT_RC_AMOUNT,
  );

  const sortedAmounts = victimDahirAmounts.sort(
    (evalA: { evaluationDate: string }, evalB: { evaluationDate: string }) => {
      return (
        new Date(evalB.evaluationDate).valueOf() -
        new Date(evalA.evaluationDate).valueOf()
      );
    },
  );
  if (!isEmpty(sortedAmounts))
    return {
      rcAmount: sortedAmounts[0].rcAmount,
      responsibilityRate: sortedAmounts[0]?.responsibilityRate,
      nextOfKins: get(sortedAmounts[0], 'nextOfKins', []),
    };
  return DEFAULT_RC_AMOUNT;
};

export const getDahirAmountByVictimKey = (
  victimKeys: any,
  deceasedVictimkeys: any,
  dahirAmount: {
    rcAmount: number;
    evaluationDate: string;
    victimKey: string;
    responsibilityRate: number;
  }[],
) => {
  if (
    (isEmpty(victimKeys) && isEmpty(deceasedVictimkeys)) ||
    isEmpty(dahirAmount)
  )
    return {};
  const dahirAmountByVictimKey: { [key: string]: any } = {};
  victimKeys.forEach((victimKey: string) => {
    const result = rcAmountByVictim(dahirAmount, victimKey);
    dahirAmountByVictimKey[victimKey] = get(result, 'rcAmount');
  });
  deceasedVictimkeys.forEach((victimKey: string) => {
    const result = rcAmountByVictim(dahirAmount, victimKey);
    dahirAmountByVictimKey[victimKey] = featureService.hasFeature(
      FEATURES.GET_DAHIR_AMOUNT_V2,
    )
      ? {
          calculatedAmount: get(result, 'rcAmount'),
          ...(!isEmpty(get(result, 'nextOfKins', [])) &&
            get(result, 'nextOfKins', []).reduce((acc: any, value: any) => {
              acc[`${value.fullName}-${value.qualityCode}`] = {
                calculatedMaterialPrejudice: parseFloat(
                  (
                    value.prejMateriel *
                    (get(result, 'responsibilityRate') / 100)
                  ).toFixed(2),
                ),
                calculatedMoralePrejudice: parseFloat(
                  (
                    value.prejMoral *
                    (get(result, 'responsibilityRate') / 100)
                  ).toFixed(2),
                ),
                totalAmount: value.totalAmounts,
              };
              acc[`nextOfKinKey-${value.nextOfKinKey}`] = {
                calculatedMaterialPrejudice: parseFloat(
                  (
                    value.prejMateriel *
                    (get(result, 'responsibilityRate') / 100)
                  ).toFixed(2),
                ),
                calculatedMoralePrejudice: parseFloat(
                  (
                    value.prejMoral *
                    (get(result, 'responsibilityRate') / 100)
                  ).toFixed(2),
                ),
                totalAmount: value.totalAmounts,
              };
              return acc;
            }, [])),
        }
      : get(result, 'rcAmount');
  });

  return dahirAmountByVictimKey;
};

export const victimKeyDahirAmount = (victims: VictimType[]) => {
  const dahirAmountByVictimKey: { [key: string]: number } = {};
  victims.map((element: VictimType) => {
    if (element.jomCalculatedAmount != null) {
      dahirAmountByVictimKey[element.victimKey] = element.jomCalculatedAmount;
    }
  });
  return dahirAmountByVictimKey;
};
export const validateCivilJudgementExpertise = (
  expertises: IExpertises,
  judgementAddDocExpertises: Expertise[],
) => {
  const isNotEmpty = (value: any) => !(!value || value.length === 0);
  const medicalVictimsLength = shouldDisplayExpertiseType(
    MEDICAL_EXPERTISE_ID,
    judgementAddDocExpertises,
  )
    ? shouldDisplayExpertiseType(
        MEDICAL_EXPERTISE_ID,
        judgementAddDocExpertises,
      )?.victims.length
    : null;
  const accountingVictimsLength = shouldDisplayExpertiseType(
    COMPTABLE_EXPERTISE_ID,
    judgementAddDocExpertises,
  )
    ? shouldDisplayExpertiseType(
        COMPTABLE_EXPERTISE_ID,
        judgementAddDocExpertises,
      )?.victims.length
    : null;
  const isMechanicalExpertiseValidated = values(
    expertises.mechanicalExpertise,
  ).every(isNotEmpty);
  const isMedicalExpertiseValidated =
    medicalVictimsLength &&
    expertises.medicalExpertise.length === medicalVictimsLength;

  const isAccountingExpertiseValidated =
    accountingVictimsLength &&
    expertises.accountingExpertise.length === accountingVictimsLength;

  if (accountingVictimsLength === null) {
    return isMechanicalExpertiseValidated && isMedicalExpertiseValidated;
  } else if (medicalVictimsLength === null) {
    return isMechanicalExpertiseValidated && isAccountingExpertiseValidated;
  }
  return (
    isMechanicalExpertiseValidated &&
    isAccountingExpertiseValidated &&
    isMedicalExpertiseValidated
  );
};

export const getJudgementOnMeritsSuedPartiesList = (listings: Listings) => {
  const suedPartiesList = get(listings, 'suedParty', []);
  return suedPartiesList.filter(el => el.id !== 2);
};
export const isDeceasedVictim = (
  judgementADDDocumen: JudgementADDDocumentType[],
) => {
  let _judgementADDDocumen = cloneDeep(judgementADDDocumen);
  let deceasedVictim: (VictimType | undefined)[] = [];
  _judgementADDDocumen.flatMap(add =>
    // eslint-disable-next-line array-callback-return
    add.expertises.flatMap(expertise => {
      const Victim = expertise.victims.find(
        victim => victim.injuryPostKey === INJURY_POST_DECEASED,
      );
      if (!isEmpty(Victim)) {
        deceasedVictim.push(Victim);
      }
    }),
  );
  return deceasedVictim;
};
export const filterCivilJudgement = (
  judgementOnMerits: JudgementOnMeritsType,
  judgementAddDocuments: JudgementADDDocumentType[],
) => {
  return filterDuplicatedForms(judgementAddDocuments);
};

export const filterDuplicatedForms = (
  newJADDExpertises: JudgementADDDocumentType[],
) => {
  return newJADDExpertises
    .map(jadd => {
      return {
        ...jadd,
        expertises: jadd.expertises
          .map(expertise => {
            return {
              ...expertise,
              victims: get(expertise, 'victims', []).filter(
                victim => !victim.isOld,
              ),
              vehicules: get(expertise, 'vehicules', []).filter(
                vehicle => !vehicle.isOld,
              ),
            };
          })
          .filter(
            expertise =>
              !isEmpty(expertise.victims) || !isEmpty(expertise.vehicules),
          ),
      };
    })
    .filter(jadd => !isEmpty(jadd.expertises));
};
export const formatCivilJudgementRecap = (
  civilJudgementOnMeritsFormMedicalExpertise: any,
  civilJudgementOnMeritsFormAccountingExpertise: any,
  civilJudgementOnMeritsFormMechanicalExpertise: any,
  newCivjs: any = [],
) => {
  const civjmede = [
    ...civilJudgementOnMeritsFormMedicalExpertise.flatMap((item: any) =>
      get(item, 'medExpertises', []),
    ),
    ...newCivjs.flatMap((item: any) => get(item, 'civjmede', [])),
  ].filter((item: any) => !get(item, 'isDeleted', false));
  const civjacce = [
    ...civilJudgementOnMeritsFormAccountingExpertise.flatMap((item: any) =>
      get(item, 'accExpertises', []),
    ),
    ...newCivjs.flatMap((item: any) => get(item, 'civjacce', [])),
  ].filter((item: any) => !get(item, 'isDeleted', false));
  const civjmece = [
    ...civilJudgementOnMeritsFormMechanicalExpertise.flatMap((item: any) =>
      get(item, 'mechanicalExpertise', []),
    ),
    ...newCivjs.flatMap((item: any) => get(item, 'civjmece', [])),
  ].filter((item: any) => !get(item, 'isDeleted', false));
  return [{ civjmede, civjmece, civjacce }];
};
export const disableSharedResponsibility = (
  sharedResponsability: any,
  beneficiaries: any = [],
  civjs: any = [],
) => {
  const jomBeneficiariesWithCompensation = beneficiaries.some(
    (beneficiary: any) => !get(beneficiary, 'isDeletedCompensation', false),
  );
  const hasCivjs = civjs.some(
    (item: any) =>
      !isEmpty(get(item, 'civjacce', [])) ||
      !isEmpty(get(item, 'civjmece', [])) ||
      !isEmpty(get(item, 'civjmede', [])),
  );
  return featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
    !isNotEmpty(sharedResponsability)
    ? (beneficiaries.length > 0 && jomBeneficiariesWithCompensation) || hasCivjs
    : !isNotEmpty(sharedResponsability);
};
export const disableOnValidationButton = (
  judgementOnMeritsInfoForm: any,
  validateDesceasedVictim: boolean,
  beneficiaries: any,
  validateCivilJudgements: boolean,
  sharedResponsability: any,
  civilJudgementOnMeritsFormMedicalExpertise: any,
  civilJudgementOnMeritsFormAccountingExpertise: any,
  civilJudgementOnMeritsFormMechanicalExpertise: any,
  civilJudgementVictimReason: Config[],
  newCivjs: any,
  victims: Victim[],
  civjvm: any,
  judgementAddDocuments: any,
) => {
  return featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION)
    ? (!isNil(get(judgementOnMeritsInfoForm, 'judgementNumber', null)) &&
        !validationCourtFileNumber(
          get(judgementOnMeritsInfoForm, 'judgementNumber', null),
        )) ||
        !validateDesceasedVictim ||
        areBeneficiariesDataInvalid(
          beneficiaries,
          civilJudgementVictimReason,
        ) ||
        !validateCivilJudgements ||
        disableSharedResponsibility(
          sharedResponsability,
          beneficiaries,
          formatCivilJudgementRecap(
            civilJudgementOnMeritsFormMedicalExpertise,
            civilJudgementOnMeritsFormAccountingExpertise,
            civilJudgementOnMeritsFormMechanicalExpertise,
            newCivjs,
          ),
        ) ||
        areAllVictimsInCivjvmRecap(
          victims,
          civjvm,
          judgementAddDocuments,
          get(judgementOnMeritsInfoForm, 'createdAt', null),
          civilJudgementVictimReason,
        )
    : false;
};
export const getCivjvmInJudgement = (judgementOnMeritsMultiple: any[] = []) => {
  return judgementOnMeritsMultiple
    .map((item: any) => get(item, 'jom.civjvm', []))
    .flat();
};

export const disableValidationButton = (
  judgementOnMerits: JudgementOnMeritsType,
  filtredCvilProceeding: any,
  judgementOnMeritsRequest: any,
  isCivilProceeding: any,
  judgementOnMeritsInfo: any,
  isCJDisabled: any,
  isRejected: boolean,
  judgementAddDocuments: any,
  sharedResponsability: any,
  beneficiaries: any,
  validateDesceasedVictim: boolean,
  civilJudgementVictimReason: Config[],
  victims: Victim[],
  isExpertReportValidated: boolean,
  isManager: boolean,
  civjvm: any = [],
  associatedVictims?: any,
) => {
  if (isRejected) return false;
  else if (isCivilProceeding) {
    return (
      (!get(judgementOnMeritsRequest, 'document.url', null) &&
        !get(judgementOnMeritsRequest, 'document.type', null)) ||
      !validationCourtFileNumber(judgementOnMeritsInfo.judgementNumber) ||
      areBeneficiariesDataInvalid(beneficiaries, civilJudgementVictimReason) ||
      disableSharedResponsibility(
        sharedResponsability,
        beneficiaries,
        get(judgementOnMeritsRequest, 'civjs', []),
      ) ||
      !Object.values(isCJDisabled).every(el => el) ||
      !validateDesceasedVictim ||
      areAllVictimsInCivjvmAdd(
        victims,
        civjvm.filter((item: any) => !isEmpty(item)),
        judgementAddDocuments,
        civilJudgementVictimReason,
        associatedVictims,
      ) ||
      (isManager && isExpertReportValidated)
    );
  }
  let jaddJudgementDate;
  if (!isEmpty(judgementAddDocuments)) {
    jaddJudgementDate = get(
      _.sortBy(
        judgementAddDocuments,
        o => new Date(moment(get(o, 'judgementDate', '')).format('DD-MM-YYYY')),
        ['ASC'],
      ),
      '[0].judgementDate',
    );
  }

  return (
    (get(filtredCvilProceeding, 'procedureNatureId') === 3 &&
      isEmpty(judgementOnMeritsRequest['cj']['suedPartys']) &&
      !isCivilProceeding &&
      !judgementOnMeritsRequest['document']) ||
    (!get(judgementOnMeritsRequest, 'document.url', null) &&
      !get(judgementOnMeritsRequest, 'document.type', null)) ||
    areBeneficiariesDataInvalid(beneficiaries, civilJudgementVictimReason) ||
    disableSharedResponsibility(
      sharedResponsability,
      beneficiaries,
      get(judgementOnMeritsRequest, 'civjs', []),
    ) ||
    judgementOnMeritsInfo.judgementNumber === '' ||
    !validationCourtFileNumber(judgementOnMeritsInfo.judgementNumber) ||
    judgementOnMeritsInfo?.judgementDate === '' ||
    judgementOnMeritsInfo?.judgementDate === 'Invalid date' ||
    new Date(judgementOnMeritsInfo?.judgementDate) > new Date() ||
    (jaddJudgementDate &&
      new Date(judgementOnMeritsInfo?.judgementDate) <
        new Date(jaddJudgementDate)) ||
    (featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
      (!Object.values(isCJDisabled).every(el => el) ||
        !validateDesceasedVictim ||
        areAllVictimsInCivjvmAdd(
          victims,
          civjvm.filter((item: any) => !isEmpty(item)),
          judgementAddDocuments,
          civilJudgementVictimReason,
          associatedVictims,
        ))) ||
    (isManager && isExpertReportValidated)
  );
};
export const getBeneficiariesValidation = (beneficiaries: any) => {
  return beneficiaries.every((beneficiary: any) => {
    return (
      !isNil(get(beneficiary, 'funeralFees')) &&
      !isNil(get(beneficiary, 'materialPrejudice')) &&
      !isNil(get(beneficiary, 'moralePrejudice'))
    );
  });
};
export const createCivilJudgementPayload = (
  withFeeNote: boolean,
  claimId: number,
  claimNumber: string,
  judgementOnMeritsId: number,
  judiciaryProcessId: number,
  civilJudgements: any,
  feeNoteAmounts: any,
  lawyerInfo: any,
) => {
  return {
    judgementOnMeritsId,
    judiciaryProcessId,
    claimId,
    claimNumber,
    civjs: civilJudgements,
    feeNote: withFeeNote
      ? {
          step: PROCEDURE_STEPS.JUDGEMENT_ON_MERITS,
          codeIntervenant: lawyerInfo.code,
        }
      : undefined,
  };
};

export const showResponsibilityShare = (
  victim: VictimType,
  isRecap: boolean,
) => {
  return isRecap && isNil(get(victim, 'responsibilityShare')) ? false : true;
};

export const getInjuredCivilJudgement = (
  judgementAddDocuments: JudgementADDDocumentType[] = [],
) => {
  return getJudgementAddDocuments(judgementAddDocuments)
    .map(jadd => ({
      ...jadd,
      expertises: jadd.expertises
        .map(exp => ({
          ...exp,
          victims: get(exp, 'victims', []).filter(victim => {
            return victim.injuryPostKey !== INJURY_POST_DECEASED;
          }),
        }))
        .filter(exp => !isEmpty(exp.victims) || !isEmpty(exp.vehicules)),
    }))
    .filter(jadd => !isEmpty(jadd.expertises));
};

export const getInjuredVictims = (
  judgementAddDocuments: JudgementADDDocumentType[],
  victims: VictimType[] = [],
) => {
  const injuredVictimWithoutExpertise: VictimType[] = [];
  const judgementAddDocumentsVictims = judgementAddDocuments.flatMap(jadd => {
    return get(jadd, 'expertises', []).flatMap((exp: any) => {
      return get(exp, 'victims', []).map((victim: VictimType) => victim.id);
    });
  });
  const injuredVictims = victims.filter(
    victim => get(victim, 'injuryPostKey', {}) !== INJURY_POST_DECEASED,
  );
  injuredVictims.forEach(victim => {
    const difference = !judgementAddDocumentsVictims.some(
      (item: any) => victim.id === item,
    );
    if (difference) {
      isEmpty(
        injuredVictimWithoutExpertise.find(
          injuredVictim => injuredVictim.id === victim.id,
        ) || {},
      ) && injuredVictimWithoutExpertise.push(victim);
    }
  });
  return injuredVictimWithoutExpertise;
};

export const isRejected = (judgementOnMerits: JudgementOnMeritsType) =>
  get(judgementOnMerits, 'judgementOnMerits.status', '') ===
  PROCEDURE_STATUSES.REJECTED;

export const filterExpertises = (judgementAddDocuments: any) => {
  const expertiseVictimIds = new Set();
  const expertiseVehicleIds = new Set();

  judgementAddDocuments.forEach((item: any) => {
    item.expertises.forEach((expertise: any) => {
      if (expertise?.expertiseId === 1) {
        get(expertise, 'victims', []).forEach((victim: VictimType) => {
          expertiseVictimIds.add(victim?.id);
        });
      }
      if (expertise?.expertiseId === 3) {
        get(expertise, 'vehicules', []).forEach((vehicle: any) => {
          expertiseVehicleIds.add(vehicle?.id);
        });
      }
    });
  });

  const filteredJADD = judgementAddDocuments
    .map((item: any) => {
      const filteredExpertises = get(item, 'expertises', [])
        .map((expertise: any) => {
          if (expertise.expertiseId === 2) {
            const filteredVictims = get(expertise, 'victims', []).filter(
              (victim: VictimType) => !expertiseVictimIds.has(victim.id),
            );
            const filteredVehicles = get(expertise, 'vehicules', []).filter(
              (vehicle: any) => !expertiseVehicleIds.has(vehicle.id),
            );
            return {
              ...expertise,
              victims: filteredVictims,
              vehicules: filteredVehicles,
            };
          }
          return expertise;
        })
        .filter(
          (item: any) =>
            !isEmpty(get(item, 'victims', [])) ||
            !isEmpty(get(item, 'vehicules', [])),
        );
      return {
        ...item,
        expertises: filteredExpertises,
      };
    })
    .filter((item: any) => !isEmpty(get(item, 'expertises', [])));

  return featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION)
    ? filteredJADD
    : judgementAddDocuments;
};
export const getAllJudgementAddDocuments = (
  injuredAppealAddDocuments: JudgementADDDocumentType[],
  judgementAddDocuments: JudgementADDDocumentType[],
) => {
  const judgement: any[] = [];
  const appeal: any[] = [];
  injuredAppealAddDocuments.forEach((jadd: any) =>
    jadd.expertises.forEach((exp: any) => {
      exp.victims.forEach((vic: any) =>
        judgement.push({
          jaddId: jadd.id,
          expertiseId: exp.expertiseId,
          victimId: vic.id,
          expertiseJudgementAddDocumentId: exp.expertiseJudgementAddDocumentId,
        }),
      );
      exp.vehicules.forEach((vic: any) =>
        judgement.push({
          jaddId: jadd.id,
          expertiseId: exp.expertiseId,
          vehiculeId: vic.id,
          expertiseJudgementAddDocumentId: exp.expertiseJudgementAddDocumentId,
        }),
      );
    }),
  );
  judgementAddDocuments.forEach((jadd: any) =>
    jadd.expertises.forEach((exp: any) => {
      exp.victims.forEach((vic: any) =>
        appeal.push({
          jaddId: jadd.id,
          expertiseId: exp.expertiseId,
          victimId: vic.id,
          expertiseJudgementAddDocumentId: exp.expertiseJudgementAddDocumentId,
        }),
      );
      exp.vehicules.forEach((vic: any) =>
        appeal.push({
          jaddId: jadd.id,
          expertiseId: exp.expertiseId,
          vehiculeId: vic.id,
          expertiseJudgementAddDocumentId: exp.expertiseJudgementAddDocumentId,
        }),
      );
    }),
  );

  const found = judgement.filter(item => {
    return !appeal.some(iteem => {
      return (
        item.expertiseId === iteem.expertiseId &&
        ((!isNil(item.victimId) && item.victimId === iteem.victimId) ||
          (!isNil(item.vehiculeId) && item.vehiculeId === iteem.vehiculeId))
      );
    });
  });

  const reducer = (prevJADD: any, currentJADD: any) => {
    let result: any[] = [];

    get(currentJADD, 'expertises', []).forEach((exp: any) => {
      exp.victims.forEach((vic: any) => {
        const hasExpertise = found.find((foundjadd: any) => {
          return (
            foundjadd.jaddId === currentJADD.id &&
            exp.expertiseId === foundjadd.expertiseId &&
            exp.expertiseJudgementAddDocumentId ===
              foundjadd.expertiseJudgementAddDocumentId &&
            vic.id === foundjadd.victimId
          );
        });
        const foundJadd = result.find(item => item.id === currentJADD.id);

        if (hasExpertise && foundJadd) {
          const checkExistanceOfExpertise = get(
            foundJadd,
            'expertises',
            [],
          ).every(
            (expertise: any) =>
              expertise.expertiseJudgementAddDocumentId !==
              exp.expertiseJudgementAddDocumentId,
          );
          let expertises: any[] = foundJadd.expertises;

          get(foundJadd, 'expertises', []).forEach((item: any) => {
            if (checkExistanceOfExpertise) {
              const victimToAdd = {
                ...exp,
                vehicules: [],
                victims: exp.victims.filter(
                  (victim: VictimType) => victim.id === vic.id,
                ),
              };

              return (expertises = [...foundJadd.expertises, victimToAdd]);
            }
            if (
              item.expertiseJudgementAddDocumentId ===
                exp.expertiseJudgementAddDocumentId &&
              get(item, 'victims', []).every((v: any) => v.id !== vic.id)
            ) {
              const addToExistingEpertise = {
                ...exp,
                victims: [
                  ...item.victims,
                  exp.victims.find(
                    (vi: any) => vi.id === hasExpertise.victimId,
                  ),
                ],
              };

              return (expertises = [
                ...expertises.filter(
                  expertise =>
                    exp.expertiseJudgementAddDocumentId !==
                    expertise.expertiseJudgementAddDocumentId,
                ),
                addToExistingEpertise,
              ]);
            }
          });

          return (result = [
            {
              ...currentJADD,
              expertises: expertises,
            },
            ...result.filter(item => item.id !== foundJadd.id),
          ]);
        }
        return (
          hasExpertise &&
          result.push({
            ...currentJADD,
            expertises: [
              {
                ...exp,
                victims: exp.victims.filter((vi: any) => vi.id === vic.id),
              },
            ],
          })
        );
      });
      exp.vehicules.forEach((veh: any) => {
        const hasExpertise = found.find((foundjadd: any) => {
          return (
            foundjadd.jaddId === currentJADD.id &&
            exp.expertiseId === foundjadd.expertiseId &&
            veh.id === foundjadd.vehiculeId &&
            exp.expertiseJudgementAddDocumentId ===
              foundjadd.expertiseJudgementAddDocumentId
          );
        });
        const foundJadd = result.find(item => item.id === currentJADD.id);

        if (hasExpertise && foundJadd) {
          const checkExistanceOfExpertise = get(
            foundJadd,
            'expertises',
            [],
          ).every(
            (expertise: any) =>
              expertise.expertiseJudgementAddDocumentId !==
              exp.expertiseJudgementAddDocumentId,
          );

          let expertises: any[] = foundJadd.expertises;
          get(foundJadd, 'expertises', []).forEach((item: any) => {
            if (checkExistanceOfExpertise) {
              const vehiculeToAdd = {
                ...exp,
                vehicules: exp.vehicules.filter(
                  (vehicule: any) => vehicule.id === veh.id,
                ),
              };

              return (expertises = [...foundJadd.expertises, vehiculeToAdd]);
            }

            if (
              item.expertiseJudgementAddDocumentId ===
                exp.expertiseJudgementAddDocumentId &&
              get(item, 'vehicules', []).every((v: any) => v.id !== veh.id)
            ) {
              const addToExistingExpertise = {
                ...exp,
                vehicules: [
                  ...item.vehicules,
                  exp.vehicules.find(
                    (vi: any) => vi.id === hasExpertise.vehiculeId,
                  ),
                ],
              };

              return (expertises = [
                ...expertises.filter(
                  expertise =>
                    exp.expertiseJudgementAddDocumentId !==
                    expertise.expertiseJudgementAddDocumentId,
                ),
                addToExistingExpertise,
              ]);
            }
          });
          return (result = [
            {
              ...currentJADD,
              expertises: expertises,
            },
            ...result.filter(item => item.id !== foundJadd.id),
          ]);
        }

        return (
          hasExpertise &&
          result.push({
            ...currentJADD,
            expertises: [
              {
                ...exp,
                vehicules: exp.vehicules.filter((v: any) => v.id === veh.id),
              },
            ],
          })
        );
      });
    });

    return [...prevJADD, ...result];
  };

  return !isEmpty(injuredAppealAddDocuments)
    ? [
        ...injuredAppealAddDocuments.reduce(reducer, []),
        ...judgementAddDocuments,
      ]
    : [...judgementAddDocuments];
};

export const resolveStatus = (
  procedureNatureId: number,
  isManager: boolean,
  runByManager: boolean,
) => {
  const CORRECTIONAL_PROCEDURE_ID = 3;
  if (
    (procedureNatureId !== CORRECTIONAL_PROCEDURE_ID || runByManager) &&
    isManager
  )
    return PROCEDURE_STATUSES.VALIDATED_WITHOUT_CONTESTATION;
  return PROCEDURE_STATUSES.PENDING;
};

export const isCivilJudgementDefined = (
  judgementAddDocuments: JudgementADDDocumentType[],
) => {
  if (isEmpty(judgementAddDocuments)) return false;
  const judgementAddDocumentsWithInjuredVictims = judgementAddDocuments.filter(
    (el: JudgementADDDocumentType) => {
      let victims: VictimType[] = [];
      get(el, 'expertises', []).forEach((exp: Expertise) => {
        victims = ([
          ...victims,
          ...get(exp, 'victims', []),
        ] as unknown) as VictimType[];
      });
      return victims.find(
        (el: VictimType) => el.injuryPostKey !== INJURY_POST_KEY.DECEASED,
      );
    },
  );
  if (isEmpty(judgementAddDocumentsWithInjuredVictims)) return false;
  return true;
};
export const isReadOnly = (
  judgementOnMerits: JudgementOnMeritsType,
  isManager: boolean,
) => {
  return isManager
    ? get(judgementOnMerits, 'judgementOnMerits.status') !== STATUS_PENDING &&
        !isEmpty(judgementOnMerits)
    : get(judgementOnMerits, 'judgementOnMerits.status') !== STATUS_REJECTED &&
        !isEmpty(judgementOnMerits);
};

export const showAddBeneficiaries = (
  isManager: Boolean,
  isRecap: Boolean,
  judgementOnMerits: any,
) => {
  return (
    !isRecap ||
    (get(judgementOnMerits, 'judgementOnMerits.status') === STATUS_REJECTED &&
      get(judgementOnMerits, 'judgementOnMerits.creator') ===
        (isManager
          ? currentUserStorage.get()?.username
          : currentIntervenantStorage.get()?.preferred_username)) ||
    (isManager &&
      get(judgementOnMerits, 'judgementOnMerits.status') === STATUS_PENDING)
  );
};
export const checkVictimExistanceCivilParty = (
  desceasedVictim: VictimType[],
  victims: VictimType[],
) => {
  const victimIds: string[] = [];
  desceasedVictim &&
    desceasedVictim.map((element: any) => {
      victimIds.push(element.victimId);
    });
  return (
    victims &&
    victimIds &&
    victims.map((element: any) => {
      return element.id && victimIds.includes(element.id);
    })
  );
};
export const getBeneficiaryContestations = (
  beneficiary: Beneficiary,
  beneficiaryContestations: any = [],
) => {
  const beneficiaryContestation =
    beneficiaryContestations.find(
      (benef: any) => benef.beneficiaryIdJom === beneficiary.beneficiaryIdJom,
    ) || {};
  return get(beneficiaryContestation, 'contest', []);
};
export const getBeneficiaryContestationReasons = (
  beneficiary: Beneficiary,
  beneficiaryContestationReasons: any = [],
) => {
  const beneficiaryContestationReason =
    Array.from(beneficiaryContestationReasons).find(
      (benef: any) =>
        benef.judgementOnMeritsBeneficiaryId === beneficiary.beneficiaryIdJom,
    ) || {};

  return get(beneficiaryContestationReason, 'reasons', []);
};
export const isDeceasedVictimContested = (
  beneficiary: Beneficiary,
  recapInfo: any,
  beneficiaryContestationReasons: any = [],
) => {
  return (
    !isEmpty(
      getBeneficiaryContestationReasons(
        beneficiary,
        beneficiaryContestationReasons,
      ),
    ) || !isEmpty(getBeneficiaryContestations(beneficiary, recapInfo))
  );
};
export const resolveSlectedDeceasedVictims = (
  deceasedVictims: any,
  associatedVictims: any,
  jomId: number,
  isMultiple: boolean | undefined = false,
) =>
  deceasedVictims
    .filter((el: any) =>
      isMultiple ? associatedVictims.includes(get(el, 'id')) : true,
    )
    .map((v: any) => {
      get(v, 'beneficiaries', []).map((b: any) => {
        const jomBeneficiary =
          get(b, 'jomBeneficiaries', []).find(
            (el: any) => el.judgementOnMeritsId === jomId,
          ) || {};
        const funeralFees = get(
          jomBeneficiary,
          'funeralFees',
          get(b, 'funeralFees', null),
        );
        const medicalFees = get(
          jomBeneficiary,
          'medicalFees',
          get(b, 'medicalFees', null),
        );

        b.funeralFees = b.isModified ? b.funeralFees : funeralFees;
        b.medicalFees = b.isModified ? b?.medicalFees : medicalFees;
      });
      return v;
    });

export const resolveInjuredVictims = (
  injuredVictim: VictimType[],
  jomAssociatedVictims: number[],
  isMultiple: boolean | undefined,
  currentJomVictimsIds: number[],
) => {
  return isMultiple
    ? injuredVictim.filter((v: any) =>
        [...jomAssociatedVictims, ...currentJomVictimsIds].includes(v.id),
      )
    : injuredVictim;
};

export const getCurrentJomVictimsIds = (
  currentJom: JudgementOnMeritsType | undefined,
) => {
  const currentJomInjuredVictimsIds = get(
    currentJom,
    'judgementOnMerits.jom.civjvm',
    [],
  ).map((v: any) => v.id);
  const currentJomVictimsIds = get(
    currentJom,
    'judgementOnMerits.jom.civjs',
    [],
  )
    .map((el: any) =>
      [
        ...get(el, 'civjacce', []).map((exp: any) => get(exp, 'victim.id')),
        ...get(el, 'civjmede', []).map((exp: any) => get(exp, 'victim.id')),
      ].flat(),
    )
    .flat();
  return [...currentJomInjuredVictimsIds, ...currentJomVictimsIds];
};

export const isOtherReasonSelected = (
  civilJudgementVictimReasons: Config[],
  reasonId: number,
  mode?: string,
) => {
  const normalRejection = civilJudgementVictimReasons.filter((item: any) =>
    isNull(item?.type),
  );
  const formRejection = civilJudgementVictimReasons.filter(
    (item: any) => item.type === CIVIL_JUDGEMENT_TYPES.FORM_REJECTION,
  );
  const substantiveRejection = civilJudgementVictimReasons.filter(
    (item: any) => item.type === CIVIL_JUDGEMENT_TYPES.SUBSTANTIVE_REJECTION,
  );
  const currentCivilJudgementVictimReason =
    mode === CIVIL_JUDGEMENT.FORM_REJECTION
      ? formRejection
      : mode === CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION
      ? substantiveRejection
      : normalRejection;
  const formRejectionwithOtherReason =
    currentCivilJudgementVictimReason.find(item => item.title === 'Autre') ||
    {};

  return Number(get(formRejectionwithOtherReason, 'id')) === Number(reasonId);
};
export const getJudgementOnMeritsByVictim = (
  jmv: JudgementOnMeritsVictim[],
  victimId: number,
) => {
  return jmv.find((item: any) => item.victimId === victimId) || {};
};
export const getCalculatedAmount = (
  dahirAmount: any,
  judgementOnMeritsRequest: any,
  civj: any,
  victim: VictimType,
) => {
  const jmv = getJudgementOnMeritsByVictim(
    get(judgementOnMeritsRequest, 'jmv', []),
    get(civj, 'victimId', victim?.id),
  );
  if (isEmpty(jmv)) {
    return get(
      dahirAmount,
      get(civj, 'victim.victimKey', victim?.victimKey),
      0,
    );
  }
  return get(jmv, 'calculatedAmount', '');
};
export const resolveJudiciaryAmount = (
  judgementOnMerits: any,
  desceasedVictims: any,
  id: any,
  judgementOnMeritsRequestJmv: any = [],
) => {
  return isEmpty(judgementOnMerits)
    ? get(
        judgementOnMeritsRequestJmv.find((el: any) => el.victimId === id),
        'compensationAmount',
        null,
      )
    : !isEmpty(judgementOnMerits) &&
        get(
          judgementOnMeritsRequestJmv.find((el: any) => el.victimId === id),
          'compensationAmount',
          get(
            desceasedVictims.find((el: any) => el.victimId === id),
            'judiciaryAmount',
            null,
          ),
        );
};
export const resolveDeceasedVictimFees = (
  judgementOnMerits: any,
  id: any,
  judgementOnMeritsRequestJmv: any = [],
) => {
  const jom = isEmpty(judgementOnMerits)
    ? judgementOnMeritsRequestJmv.find((el: any) => el.victimId === id) || {}
    : judgementOnMeritsRequestJmv.find((el: any) => el.victimId === id) || {};
  return {
    medicalFees: get(jom, 'medicalFees', null),
    funeralFees: get(jom, 'funeralFees', null),
  };
};
export const resolveCalculatedAmount = (
  victim: VictimType,
  dahirAmount: any,
  judgementOnMeritsRequest: any = [],
) => {
  const jmv =
    getJudgementOnMeritsByVictim(
      get(judgementOnMeritsRequest, 'jmv', []),
      (victim?.id as unknown) as number,
    ) || {};
  return isEmpty(jmv)
    ? featureService.hasFeature(FEATURES.GET_DAHIR_AMOUNT_V2)
      ? get(
          dahirAmount[victim.victimKey],
          'calculatedAmount',
          victim?.calculatedEvaluation,
        )
      : dahirAmount[victim.victimKey]
    : isNil(get(jmv, 'calculatedAmount'))
    ? get(
        dahirAmount[victim.victimKey],
        'calculatedAmount',
        victim?.calculatedEvaluation,
      )
    : get(jmv, 'calculatedAmount', 0);
};

export const getDeceasedVictims = (
  judgementAdd: any,
  judgementAddAppeal: any,
  currentJudiciaryProcess: any,
) => {
  const deceasedVictimkeys = uniq(
    getVictimKeys(get(judgementAdd, 'judgementAddDocuments', []), true),
  );

  const oldDeceasedVictimkeys = uniq(
    getVictimKeys(get(judgementAddAppeal, 'judgementAddDocuments', []), true),
  );
  const civilDocumentVictimKeys = uniq(
    get(judgementAdd, 'civilDocuments', []).flatMap((el: any) => {
      return get(el, 'victims', []).map(
        (victim: VictimType) => victim.victimKey,
      );
    }),
  );
  const oldCivilDocumentVictimKeys = uniq(
    get(judgementAddAppeal, 'civilDocuments', []).flatMap((el: any) => {
      return get(el, 'victims', []).map(
        (victim: VictimType) => victim.victimKey,
      );
    }),
  );
  const judiciaryProcessVictimKeys = uniq(
    get(currentJudiciaryProcess, 'victims', []).map((el: any) => el.victimKey),
  );
  return !isEmpty(get(judgementAdd, 'deceasedVictim', []))
    ? get(judgementAdd, 'deceasedVictim', []).filter((el: any) =>
        uniq([
          ...deceasedVictimkeys,
          ...oldDeceasedVictimkeys,
          ...civilDocumentVictimKeys,
          ...oldCivilDocumentVictimKeys,
          ...judiciaryProcessVictimKeys,
        ]).includes(el.victimKey),
      )
    : get(currentJudiciaryProcess, 'victims', []).filter(
        (item: any) => item.injuryPostKey === '2',
      );
};
export const getCivilJudgementVictims = (civilJudgement: any) => {
  let victimIds: any[] = [];
  civilJudgement.forEach((item: any) => {
    get(item, 'civjmede', []).map((el: any) => {
      const exists = victimIds.find(victim => el.victimId === victim.id) || {};
      isEmpty(exists) &&
        el.victimId &&
        victimIds.push({
          id: el.victimId,
          victimKey: get(el, 'victim.victimKey', el?.victimKey),
        });
    });

    get(item, 'civjacce', []).map((el: any) => {
      const exists = victimIds.find(victim => el.victimId === victim.id) || {};
      isEmpty(exists) &&
        el.victimId &&
        victimIds.push({
          id: el.victimId,
          victimKey: get(el, 'victim.victimKey', el?.victimKey),
        });
    });
  });
  return victimIds;
};
export const getJudgementOnMeritsVictims = (
  civilJudgement: any,
  judgementOnMerits: any,
  judgementAdd: any,
  judgementAddAppeal: any,
  currentJudiciaryProcess: any,
  dahirAmount: any,
  responsibilityShare: number,
  jmv: JudgementOnMeritsVictim[] = [],
  associatedVictims: any = [],
  jomDeceasedVictims: any = [],
  isMultiple: any = false,
) => {
  const judgementOnMeritsVictims = [...jmv];
  const deceasedVictimInJom = resolveSlectedDeceasedVictims(
    getDeceasedVictims(
      judgementAdd,
      judgementAddAppeal,
      currentJudiciaryProcess,
    ),
    [...associatedVictims, ...jomDeceasedVictims],
    get(judgementOnMerits, 'judgementOnMerits.jom.id', ''),
    isMultiple,
  );
  const civilVictims = getCivilJudgementVictims(civilJudgement);
  formatJudgementOnMeritsVictim(
    judgementOnMerits,
    deceasedVictimInJom,
    judgementOnMeritsVictims,
    dahirAmount,
    true && featureService.hasFeature(FEATURES.GET_DAHIR_AMOUNT_V2),
    responsibilityShare,
  );
  formatJudgementOnMeritsVictim(
    judgementOnMerits,
    civilVictims,
    judgementOnMeritsVictims,
    dahirAmount,
    false,
    responsibilityShare,
  );
  return judgementOnMeritsVictims;
};
export const formatJudgementOnMeritsVictim = (
  judgementOnMerits: any,
  victims: any,
  judgementOnMeritsVictims: JudgementOnMeritsVictim[],
  dahirAmount: any,
  isDeceased: boolean,
  responsibilityShare: number,
) => {
  victims.map((item: any) => {
    const existingVictim =
      judgementOnMeritsVictims.find((el: any) => {
        return item.id === el.victimId;
      }) || ({} as any);
    if (
      !isEmpty(existingVictim) &&
      item?.injuryPostKey === INJURY_POST_DECEASED &&
      judgementOnMeritsVictims.indexOf(existingVictim) !== -1
    ) {
      const { victim, ...rest } = judgementOnMeritsVictims[
        judgementOnMeritsVictims.indexOf(existingVictim)
      ] as any;
      judgementOnMeritsVictims[
        judgementOnMeritsVictims.indexOf(existingVictim)
      ] = {
        ...rest,
        responsibilityShare,
        medicalFees: !!get(rest, 'medicalFees', null)
          ? get(rest, 'medicalFees', null)
          : null,
        funeralFees: !!get(rest, 'funeralFees', null)
          ? get(rest, 'funeralFees', null)
          : null,
        calculatedAmount: isNil(rest['calculatedAmount'])
          ? isDeceased
            ? get(dahirAmount[item?.victimKey], 'calculatedAmount')
            : get(dahirAmount, item?.victimKey)
          : rest['calculatedAmount'],
      };
    }
    if (
      !isEmpty(existingVictim) &&
      !get(existingVictim, 'calculatedAmount') &&
      judgementOnMeritsVictims.indexOf(existingVictim) !== -1
    ) {
      const { victim, ...rest } = judgementOnMeritsVictims[
        judgementOnMeritsVictims.indexOf(existingVictim)
      ] as any;
      const calculatedAmount = isDeceased
        ? get(
            dahirAmount[get(existingVictim, 'victim.victimKey', '')],
            'calculatedAmount',
            get(existingVictim, 'calculatedAmount'),
          )
        : get(dahirAmount, get(existingVictim, 'victim.victimKey', ''));

      judgementOnMeritsVictims[
        judgementOnMeritsVictims.indexOf(existingVictim)
      ] = {
        ...rest,
        responsibilityShare:
          item?.injuryPostKey === INJURY_POST_DECEASED
            ? responsibilityShare
            : undefined,
        calculatedAmount: isNil(get(existingVictim, 'calculatedAmount'))
          ? calculatedAmount
          : get(existingVictim, 'calculatedAmount'),
      };
    } else if (isEmpty(existingVictim)) {
      judgementOnMeritsVictims.push({
        judgementOnMeritsId: get(
          judgementOnMerits,
          'judgementOnMerits.jom.id',
          undefined,
        ),
        victimId: get(item, 'id'),
        compensationAmount: get(item, 'judiciaryAmount', undefined),
        calculatedAmount: isDeceased
          ? get(dahirAmount[item?.victimKey], 'calculatedAmount')
          : get(dahirAmount, item?.victimKey),
        responsibilityShare:
          item?.injuryPostKey === INJURY_POST_DECEASED
            ? responsibilityShare
            : undefined,
      });
    }
  });
};
export const beneficiaryConsistencyCheck = (beneficiary: any) => {
  return (
    (!isEmpty(get(beneficiary, 'beneficiaryWithoutCompensation', {})) &&
      !get(beneficiary, 'beneficiaryWithoutCompensation,isDeleted', false)) ||
    parseFloat(String(get(beneficiary, 'materialPrejudice', 0) || 0)) +
      parseFloat(String(get(beneficiary, 'moralePrejudice', 0) || 0)) +
      parseFloat(String(get(beneficiary, 'funeralFees', 0) || 0)) +
      parseFloat(String(get(beneficiary, 'medicalFees', 0) || 0)) ===
      parseFloat(String(get(beneficiary, 'judgementAmount', 0) || 0))
  );
};
export const victimConsistencyCheck = (
  judgementOnMerits: any,
  victim: VictimType,
  jmv: any,
  desceasedVictims: any,
) => {
  const compensationAmount = resolveJudiciaryAmount(
    judgementOnMerits,
    desceasedVictims,
    get(victim, 'id', ''),
    jmv,
  );
  const { medicalFees, funeralFees } = resolveDeceasedVictimFees(
    judgementOnMerits,
    get(victim, 'id'),
    jmv,
  );
  const judgementAmounts = get(victim, 'beneficiaries', [])
    .filter((item: any) => !get(item, 'isDeletedCompensation', false))
    .map((item: any) => get(item, 'judgementAmount', 0));
  const result = judgementAmounts.reduce((accumulator: any, current: any) => {
    return accumulator + parseFloat(String(current || 0));
  }, 0);

  return (
    result + Number(medicalFees) + Number(funeralFees) ===
      parseFloat(String(compensationAmount)) ||
    get(victim, 'beneficiaries', []).every(
      (item: any) =>
        !isEmpty(get(item, 'beneficiaryWithoutCompensation', {})) &&
        !get(item, 'beneficiaryWithoutCompensation.isDeleted', false),
    )
  );
};
const getVictimFees = (
  judgementOnMeritsRequest: any,
  victimId: any,
  field: string,
) => {
  return get(
    getJudgementOnMeritsByVictim(
      get(judgementOnMeritsRequest, 'jmv', []),
      victimId,
    ),
    `${field}`,
    '',
  );
};
const isEmptyBeneficiaryFees = (victim: VictimType, field: any) => {
  return get(victim, 'beneficiaries', [])
    .filter((item: any) => !get(item, 'isDeletedCompensation', false))
    .every((el: any) => {
      return (
        isEmpty(String(get(el, `${field}`, ''))) ||
        get(el, `${field}`, '') === null
      );
    });
};
export const shouldShowFees = (
  desceasedVictims: any,
  judgementOnMeritsRequest: any,
  setShowFuneralFees: Function,
) => {
  let result = {} as any;
  desceasedVictims.map((item: any) => {
    const funeralFees = getVictimFees(
      judgementOnMeritsRequest,
      item.id,
      JUDGEMENT_ON_MERITS_VICTIM.FUNERAL_FEES,
    );
    const medicalFees = getVictimFees(
      judgementOnMeritsRequest,
      item.id,
      JUDGEMENT_ON_MERITS_VICTIM.MEDICAL_FEES,
    );
    const emptyBeneficiaryFuneralFees = isEmptyBeneficiaryFees(
      item,
      BENEFICIARY.FRAIS,
    );
    const emptyBeneficiaryMedicalFees = isEmptyBeneficiaryFees(
      item,
      BENEFICIARY.MEDICAL_FFES,
    );

    const allBeneficiariesWithoutCompensation = get(
      item,
      'beneficiaries',
      [],
    ).every((beneficiary: any) => {
      return (
        !isEmpty(get(beneficiary, 'beneficiaryWithoutCompensation', {})) &&
        !get(beneficiary, 'beneficiaryWithoutCompensation.isDeleted', false)
      );
    });

    if (
      allBeneficiariesWithoutCompensation &&
      !isEmpty(get(item, 'beneficiaries', []))
    ) {
      result[item.id] = {
        [`${FEES.FUNERAL_BENEFICIARY_FEES}`]: true,
        [`${FEES.MEDICAL_BENEFICIARY_FEES}`]: true,
        [`${FEES.FUNERAL_VICTIM_FEES}`]: false,
        [`${FEES.MEDICAL_VICTIM_FEES}`]: false,
      };
    } else {
      assignFees(
        emptyBeneficiaryFuneralFees,
        funeralFees,
        result,
        item.id,
        FEES.FUNERAL_BENEFICIARY_FEES,
        FEES.FUNERAL_VICTIM_FEES,
      );
      assignFees(
        emptyBeneficiaryMedicalFees,
        medicalFees,
        result,
        item.id,
        FEES.MEDICAL_BENEFICIARY_FEES,
        FEES.MEDICAL_VICTIM_FEES,
      );
    }
  });
  setShowFuneralFees(result);
};
const assignFees = (
  emptyBeneficiaryFees: boolean,
  fees: any,
  result: any,
  victimId: number,
  beneficiaryFees: string,
  victimFees: string,
) => {
  if (emptyBeneficiaryFees && !isEmpty(String(fees)) && !isNull(fees)) {
    return (result[victimId] = {
      ...result[victimId],
      [`${beneficiaryFees}`]: true,
      [`${victimFees}`]: false,
    });
  }
  if (!emptyBeneficiaryFees && (isEmpty(String(fees)) || isNull(fees))) {
    return (result[victimId] = {
      ...result[victimId],
      [`${beneficiaryFees}`]: false,
      [`${victimFees}`]: true,
    });
  }
  if (emptyBeneficiaryFees && (isEmpty(String(fees)) || isNull(fees))) {
    return (result[victimId] = {
      ...result[victimId],
      [`${beneficiaryFees}`]: false,
      [`${victimFees}`]: false,
    });
  }
};
export const getCalculatedAmountByBeneficiary = (
  judgementOnMerits: any,
  dahirAmountByVictimKey: any,
  element: any,
  victimKey: string,
) => {
  const showDahirAmount =
    isEmpty(judgementOnMerits) ||
    get(judgementOnMerits, 'judgementOnMerits.status') === STATUS_PENDING ||
    get(judgementOnMerits, 'judgementOnMerits.status') === STATUS_REJECTED;

  return {
    calculatedMoralePrejudice:
      isNull(get(element, 'calculatedMoralePrejudice', null)) && showDahirAmount
        ? get(dahirAmountByVictimKey[victimKey], [
            [
              `${element?.beneficiary?.firstName} ${element?.beneficiary?.lastName}-${element?.beneficiary?.beneficiaryType}`,
            ] as any,
            'calculatedMoralePrejudice',
          ])
        : get(element, 'calculatedMoralePrejudice', null),
    calculatedMaterialPrejudice:
      isNull(get(element, 'calculatedMaterialPrejudice', null)) &&
      showDahirAmount
        ? get(dahirAmountByVictimKey[victimKey], [
            [
              `${element?.beneficiary?.firstName} ${element?.beneficiary?.lastName}-${element?.beneficiary?.beneficiaryType}`,
            ] as any,
            'calculatedMaterialPrejudice',
          ])
        : get(element, 'calculatedMaterialPrejudice', null),
  };
};

export const getVictimIds = (
  judgementADDDocuments: JudgementADDDocumentType[],
) => {
  let _judgementADDDocument = cloneDeep(judgementADDDocuments);
  return _judgementADDDocument?.flatMap(add =>
    add.expertises.flatMap(expertise => expertise.victims.flatMap(v => v.id)),
  );
};

export const getVehiculeIds = (
  judgementADDDocuments: JudgementADDDocumentType[],
) => {
  let _judgementADDDocument = cloneDeep(judgementADDDocuments);
  return _judgementADDDocument?.flatMap(add =>
    add.expertises.flatMap(expertise => expertise.vehicules.flatMap(v => v.id)),
  );
};

export const resolveJudiciaryProcessType = (procedureNatureId: any) => {
  if (procedureNatureId === 3) {
    return 'correctionnelle';
  } else if (procedureNatureId === 2) {
    return 'civile';
  } else if (procedureNatureId === 1) {
    return 'commerciale';
  }
  return '';
};
export const getInjuredVictimReasons = (listings: Listings, mode: any) => {
  const civilJudgementVictimReason = get(
    listings,
    'civilJudgementVictimReason',
    [],
  ).filter((item: any) => isNull(item?.type));
  const formRejection = get(listings, 'civilJudgementVictimReason', []).filter(
    (item: any) => item.type === CIVIL_JUDGEMENT_TYPES.FORM_REJECTION,
  );
  const substantiveRejection = get(
    listings,
    'civilJudgementVictimReason',
    [],
  ).filter(
    (item: any) => item.type === CIVIL_JUDGEMENT_TYPES.SUBSTANTIVE_REJECTION,
  );
  return mode === CIVIL_JUDGEMENT.FORM_REJECTION
    ? formRejection
    : mode === CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION
    ? substantiveRejection
    : civilJudgementVictimReason;
};
export const getCivjvmRequestWithExpertise = (
  civjvmRequest: any,
  civj: any,
  isOld?: boolean,
) => {
  return civjvmRequest.filter((item: any) => {
    return !isOld
      ? item?.id
      : true &&
          Number(item?.expertiseJudgementAddDocumentId) ===
            Number(
              get(
                civj,
                'expertiseJudgementAddDocumentId',
                get(civj, 'expertiseJudgmentAddDocumentId'),
              ),
            );
  });
};
export const getNewCivjvmWithExpertise = (
  civjvmRequest: any,
  civj: any,
  incidentType: string,
) => {
  const incidentId =
    incidentType === INCIDENT_TYPE.VEHICLE ? 'vehicleId' : 'victimId';
  const civjIncidentId =
    incidentType === INCIDENT_TYPE.VEHICLE ? 'vehiculeId' : 'victimId';

  return (
    civjvmRequest.find((item: any) => {
      return (
        !item?.id &&
        Number(item?.expertiseJudgementAddDocumentId) ===
          Number(
            get(
              civj,
              'expertiseJudgementAddDocumentId',
              get(civj, 'expertiseJudgmentAddDocumentId'),
            ),
          ) &&
        get(civj, `${civjIncidentId}`) === Number(get(item, `${incidentId}`))
      );
    }) || {}
  );
};
export const getNewCivjWithExpertise = (
  civjvm: any,
  civjs: any,
  incidentType: string,
) => {
  const incidentId =
    incidentType === INCIDENT_TYPE.VEHICLE ? 'vehicleId' : 'victimId';
  const civjIncidentId =
    incidentType === INCIDENT_TYPE.VEHICLE ? 'vehiculeId' : 'victimId';

  return (
    civjs.find((item: any) => {
      return (
        get(civjvm, `${incidentId}`) ===
          Number(get(item, `${civjIncidentId}`)) &&
        !item.id &&
        Number(civjvm?.expertiseJudgementAddDocumentId) ===
          Number(
            get(
              item,
              'expertiseJudgementAddDocumentId',
              get(item, 'expertiseJudgmentAddDocumentId'),
            ),
          )
      );
    }) || {}
  );
};
export const getNewCivj = (
  expertises: any,
  currentCivjvm: any,
  incidentType: string,
) => {
  const incidentId =
    incidentType === INCIDENT_TYPE.VEHICLE ? 'vehicleId' : 'victimId';
  const civjIncidentId =
    incidentType === INCIDENT_TYPE.VEHICLE ? 'vehiculeId' : 'victimId';

  return (
    expertises.find((item: any) => {
      return (
        !item.id &&
        Number(
          get(
            item,
            'expertiseJudgementAddDocumentId',
            get(item, 'expertiseJudgmentAddDocumentId'),
          ),
        ) === Number(get(currentCivjvm, 'expertiseJudgementAddDocumentId')) &&
        get(currentCivjvm, `${incidentId}`) ===
          Number(get(item, `${civjIncidentId}`))
      );
    }) || {}
  );
};
export const shouldArchivateCurrentExpertise = (
  expertiseType: any,
  civj: any,
  civilJudgementUpdateExpertise: any,
  setCivilJudgementUpdateExpertise: any,
  civilJudgements: any,
  setCivilJudgements: any,
  toArchivate: boolean,
) => {
  const civilJudgementToUpdate = [...civilJudgementUpdateExpertise];
  const civilJudgementState = [...civilJudgements];
  const civjType =
    expertiseType === EXPERTISES.ACCOUNTING_EXPERTISE
      ? 'civjacce'
      : expertiseType === EXPERTISES.MEDICAL_EXPERTISE
      ? 'civjmede'
      : 'civjmece';
  const civilJudgement =
    civilJudgementToUpdate.find(
      (item: any) => item?.id === get(civj, 'civilJudgementId'),
    ) || {};
  const currentCivj =
    civilJudgementState.find(
      (item: any) => item?.id === get(civj, 'civilJudgementId'),
    ) || {};
  const expertises =
    expertiseType === EXPERTISES.ACCOUNTING_EXPERTISE
      ? 'accExpertises'
      : expertiseType === EXPERTISES.MEDICAL_EXPERTISE
      ? 'medExpertises'
      : 'mechanicalExpertise';

  const currentCivilJudgementIndex = civilJudgementToUpdate.indexOf(
    civilJudgement,
  );
  const currentCivjIndex = civilJudgementState.indexOf(currentCivj);
  const currentCivilJudgement =
    civilJudgementToUpdate[currentCivilJudgementIndex];
  const currentCivjState = civilJudgementState[currentCivjIndex];
  const currentExpertise = get(currentCivilJudgement, expertises, []).find(
    (item: any) => item.id === get(civj, 'id'),
  );
  const currentCivjExpertise = get(currentCivjState, civjType, []).find(
    (item: any) => item.id === get(civj, 'id'),
  );

  const index = get(currentCivilJudgement, `${expertises}`, []).indexOf(
    currentExpertise,
  );

  get(currentCivilJudgement, expertises, [])[index] = {
    ...currentExpertise,
    isDeleted: toArchivate,
  };
  get(currentCivjState, civjType, [])[
    get(currentCivjState, `${civjType}`, []).indexOf(currentCivjExpertise)
  ] = {
    ...currentCivjExpertise,
    isDeleted: toArchivate,
  };
  setCivilJudgements && setCivilJudgements(civilJudgementState);
  setCivilJudgementUpdateExpertise &&
    setCivilJudgementUpdateExpertise(civilJudgementToUpdate);
};
export const isReasonTypeDifferent = (
  civjWithNonCompensation: any,
  civilJudgementVictimReason: any[],
  currentReason: string,
) => {
  const currentCivilJudgementVictimReason =
    civilJudgementVictimReason.find(
      item => item.id === get(civjWithNonCompensation, 'reasonId'),
    ) || {};
  return get(currentCivilJudgementVictimReason, 'type') !== currentReason;
};

export const hasOtherReason = (
  civilJudgementVictimReason: any,
  reasonId: any,
) => {
  const civilJudgementVictim = civilJudgementVictimReason.filter(
    (item: any) => item?.title === 'Autre',
  );
  return !isEmpty(
    civilJudgementVictim.find((item: any) => item.id === reasonId) || {},
  );
};
export const activateCivilJudgementCompensation = (
  expertise: any,
  judgementProp: any,
  civj: any,
  modeType: string,
  judgementForNonCompensation: any,
  expertiseJudgementAddDocumentId: any,
  setJudgement: Function,
  victim: VictimType,
  vehicle: any,
) => {
  const isCivilRecap =
    judgementForNonCompensation === JUDGEMENT_EXPERTISE_TYPES.CIVIL;

  if (
    modeType === MODE_TYPES.RECAP &&
    isCivilRecap &&
    !get(civj, 'isDeleted') &&
    !!civj?.id
  ) {
    const judgement = { ...judgementProp };
    const civilJudgementVictimKey = `${expertiseJudgementAddDocumentId}-${expertise}-${
      !!victim ? get(victim, 'id', '') : get(vehicle, 'id', '')
    }`;

    if (!judgement[civilJudgementVictimKey]) {
      judgement[civilJudgementVictimKey] = {
        ...EMPTY_CIVIL_JUDGEMENT,
        ...(!!victim
          ? { civilJudgementVictimRecap: true }
          : { civilJudgementVehicleRecap: true }),
      };
      setJudgement(judgement);
    }
  }
};
export const activateCivilJudgementNonCompensation = (
  judgementProp: any,
  civjWithNonCompensation: any,
  modeType: string,
  judgementForNonCompensation: any,
  expertiseJudgementAddDocumentId: any,
  setJudgement: Function,
  victim: VictimType,
  vehicle: any,
  listings: any,
) => {
  const isFormInCivilRecap =
    judgementForNonCompensation ===
    JUDGEMENT_EXPERTISE_TYPES.CIVIL_AND_NON_COMPENSATION;

  if (
    modeType === MODE_TYPES.RECAP &&
    isFormInCivilRecap &&
    !get(civjWithNonCompensation, 'isDeleted')
  ) {
    const judgement = { ...judgementProp };
    const currentNonCompensationJudgement =
      get(listings, 'civilJudgementVictimReason', []).find(
        (item: any) => item.id === get(civjWithNonCompensation, 'reasonId'),
      ) || {};
    const nonCompensationJudgementKey = `${expertiseJudgementAddDocumentId}-${
      !!victim ? get(victim, 'id') : get(vehicle, 'id')
    }`;
    const currentNonCompensation = get(
      CIVIL_JUDGEMENT,
      get(currentNonCompensationJudgement, 'type'),
    );

    const index =
      currentNonCompensation === CIVIL_JUDGEMENT.FORM_REJECTION
        ? CIVIL_JUDGEMENT.FORM_REJECTION_RECAP
        : CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION_RECAP;
    const isDifferent = isReasonTypeDifferent(
      civjWithNonCompensation,
      get(listings, 'civilJudgementVictimReason', []),
      get(
        judgement[nonCompensationJudgementKey],
        CIVIL_JUDGEMENT.FORM_REJECTION_RECAP,
      )
        ? CIVIL_JUDGEMENT_TYPES.FORM_REJECTION
        : CIVIL_JUDGEMENT_TYPES.SUBSTANTIVE_REJECTION,
    );
    if (
      (!get(judgement[nonCompensationJudgementKey], index, false) &&
        !isDifferent) ||
      !judgement[nonCompensationJudgementKey]
    ) {
      judgement[nonCompensationJudgementKey] = {
        ...EMPTY_CIVIL_JUDGEMENT,
        [index]: true,
      };
      setJudgement({ ...judgement });
    }
  }
};
export const activateJudgementWithoutCompensation = (
  judgementProp: any,
  civjWithNonCompensation: any,
  modeType: string,
  judgementForNonCompensation: any,
  setJudgement: Function,
  victim: VictimType,
  vehicle: any,
  listings: any,
) => {
  const isFormRecap =
    judgementForNonCompensation === JUDGEMENT_EXPERTISE_TYPES.NON_COMPENSATION;

  if (
    modeType === MODE_TYPES.RECAP &&
    isFormRecap &&
    !get(civjWithNonCompensation, 'isDeleted')
  ) {
    const judgement = { ...judgementProp };
    const currentNonCompensationJudgement =
      get(listings, 'civilJudgementVictimReason', []).find(
        (item: any) => item.id === get(civjWithNonCompensation, 'reasonId'),
      ) || {};
    const nonCompensationJudgementKey = !!victim
      ? get(victim, 'id')
      : get(vehicle, 'id');

    const currentNonCompensation = get(
      CIVIL_JUDGEMENT,
      get(currentNonCompensationJudgement, 'type'),
    );
    const index =
      currentNonCompensation === CIVIL_JUDGEMENT.FORM_REJECTION
        ? CIVIL_JUDGEMENT.FORM_REJECTION_RECAP
        : CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION_RECAP;
    const isDifferent = isReasonTypeDifferent(
      civjWithNonCompensation,
      get(listings, 'civilJudgementVictimReason', []),
      get(
        judgement[nonCompensationJudgementKey],
        CIVIL_JUDGEMENT.FORM_REJECTION_RECAP,
      )
        ? CIVIL_JUDGEMENT_TYPES.FORM_REJECTION
        : CIVIL_JUDGEMENT_TYPES.SUBSTANTIVE_REJECTION,
    );
    if (
      (!get(judgement[nonCompensationJudgementKey], index, false) &&
        !isDifferent) ||
      !judgement[nonCompensationJudgementKey]
    ) {
      judgement[nonCompensationJudgementKey] = {
        ...EMPTY_CIVIL_JUDGEMENT,
        [index]: true,
      };

      setJudgement({ ...judgement });
    }
  }
};
export const hasAccountingExpertise = (
  recentAccountingExpertises: any,
  id: any,
) => {
  const accountingExpertise =
    recentAccountingExpertises.find((item: any) => item.id === id) || {};

  return {
    hasAccountingExpertise: !isEmpty(accountingExpertise),
    withExpertReport: get(accountingExpertise, 'withExpertReport', false),
    accountingExpertise,
  };
};
export const updateShowFees = (
  victimId: number,
  setShowFees: Function,
  showFees: any,
  show: boolean,
  field: string,
) => {
  setShowFees({
    ...showFees,
    [victimId]: {
      ...showFees[victimId],
      [`${field}`]: show,
    },
  });
};
export const formatExpertisesWithExpertReport = (
  jadd: any,
  victimExpertises: any,
  vehicleExpertises: any,
) => {
  const victimExpertiseMap = new Map<number, number[]>();
  const vehicleExpertiseMap = new Map<number, number[]>();

  victimExpertises.forEach((ve: any) => {
    if (!victimExpertiseMap.has(ve.victimId)) {
      victimExpertiseMap.set(ve.victimId, []);
    }
    victimExpertiseMap.get(ve.victimId)?.push(ve.expertiseId);
  });

  vehicleExpertises.forEach((ve: any) => {
    if (!vehicleExpertiseMap.has(ve.vehiculeId)) {
      vehicleExpertiseMap.set(ve.vehiculeId, []);
    }
    vehicleExpertiseMap.get(ve.vehiculeId)?.push(ve.expertiseId);
  });
  const nonFirstInstanceVictimExpertises = victimExpertises.filter(
    (ve: any) => !ve.isFirstInstance,
  );
  const nonFirstInstanceVehicleExpertises = vehicleExpertises.filter(
    (ve: any) => !ve.isFirstInstance,
  );
  return jadd
    .map((j: any) => {
      const isAppeal = j.isAppeal;
      return {
        ...j,
        expertises: j.expertises.map((e: any) => {
          const victims = e.victims.map((v: any) => {
            const expertiseIds = victimExpertiseMap.get(v.id) || [];
            const withExpertReport = expertiseIds.includes(e.expertiseId);
            if (isAppeal) {
              const existsInNonFirstInstance = nonFirstInstanceVictimExpertises.some(
                (ve: any) =>
                  ve.expertiseId === e.expertiseId && ve.victimId === v.id,
              );
              return {
                ...v,
                withExpertReport: existsInNonFirstInstance,
              };
            }
            return { ...v, withExpertReport };
          });
          const vehicules = e.vehicules.map((v: any) => {
            const expertiseIds = vehicleExpertiseMap.get(v.id) || [];
            const withExpertReport = expertiseIds.includes(e.expertiseId);
            if (isAppeal) {
              const existsInNonFirstInstance = nonFirstInstanceVehicleExpertises.some(
                (ve: any) =>
                  ve.expertiseId === e.expertiseId && ve.vehiculeId === v.id,
              );
              return {
                ...v,
                withExpertReport: existsInNonFirstInstance,
              };
            }
            return { ...v, withExpertReport };
          });
          return { ...e, victims, vehicules };
        }),
      };
    })
    .flat();
};
export const disabledJudgementWithCompensation = (
  currentExpertise: any,
  withAccountingExpertise: any,
  isDisabled: boolean,
) => {
  return (
    !get(currentExpertise, 'withExpertReport') ||
    (get(withAccountingExpertise, 'hasAccountingExpertise')
      ? !get(withAccountingExpertise, 'withExpertReport')
      : false) ||
    isDisabled
  );
};

export const priorityClaimReason = (
  sagisEvaluations: any,
  provision: number = 0,
  listings: any,
  expertiseReports?: any,
) => {
  let ippRates = [];
  let rateRecovery = [];
  let ratePretium = [];
  let rateAestheticDamageWithoutConsequence = [];
  let rateAestheticDamageWithConsequence = [];
  let rateCareerPrejudice = [];
  let rateSchoolingPrejudice = [];
  const conditionRevenu = !expertiseReports
    ? !!sagisEvaluations.find(
        (el: any) =>
          el.revenu >= MAX_ACCOUNTING_EXPERTISE_AMOUNT && el.expType === 2,
      )
    : expertiseReports &&
      !!expertiseReports.find(
        (el: any) =>
          el.fixedAnnualIncome >= MAX_ACCOUNTING_EXPERTISE_AMOUNT &&
          el.expertiseId === 2,
      );
  if (expertiseReports && !isEmpty(expertiseReports)) {
    ippRates = expertiseReports.map((el: any) => Number(el.ipp));
    rateRecovery = expertiseReports.map((el: any) =>
      Number(el.thirdPartyAppeal),
    );
    ratePretium = expertiseReports.map((el: any) => Number(el.pretiumDoloris));
    rateAestheticDamageWithoutConsequence = expertiseReports.map((el: any) =>
      Number(el.aestheticDamageWithoutConsequence),
    );
    rateAestheticDamageWithConsequence = expertiseReports.map((el: any) =>
      Number(el.aestheticDamageWithConsequence),
    );
    rateCareerPrejudice = expertiseReports.map((el: any) =>
      Number(el.careerPrejudice),
    );
    rateSchoolingPrejudice = expertiseReports.map((el: any) =>
      Number(el.schoolingPrejudice),
    );
  }

  if (!isEmpty(sagisEvaluations) && !expertiseReports) {
    ippRates = sagisEvaluations.map((el: any) => Number(el.rateIPP));
    rateRecovery = sagisEvaluations.map((el: any) => Number(el.rateRecovery));
    ratePretium = sagisEvaluations.map((el: any) => Number(el.ratePretium));
    rateAestheticDamageWithoutConsequence = sagisEvaluations.map((el: any) =>
      Number(el.rateAestheticDamageWithoutConsequence),
    );
    rateAestheticDamageWithConsequence = sagisEvaluations.map((el: any) =>
      Number(el.rateAestheticDamageWithConsequence),
    );
    rateCareerPrejudice = sagisEvaluations.map((el: any) =>
      Number(el.rateCareerPrejudice),
    );
    rateSchoolingPrejudice = sagisEvaluations.map((el: any) =>
      Number(el.rateSchoolingPrejudice),
    );
  }
  if (provision >= MAX_PROVISION) {
    return get(
      get(listings, 'priorityClaimReason', []).find(
        (el: any) => el.title === 'Provision',
      ),
      'id',
    );
  } else if (
    !!ippRates.find((ipp: any) => ipp >= MAX_IPP_RATE) &&
    (!!rateRecovery.find((el: any) => el) ||
      !!rateAestheticDamageWithConsequence.find((el: any) => el) ||
      !!rateCareerPrejudice.find((el: any) => el))
  ) {
    return get(
      get(listings, 'priorityClaimReason', []).find(
        (el: any) => el.title === 'Expertise Médicale',
      ),
      'id',
    );
  } else if (conditionRevenu) {
    return get(
      get(listings, 'priorityClaimReason', []).find(
        (el: any) => el.title === 'Expertise comptable',
      ),
      'id',
    );
  }
};
// To remove any empty civil judgement bloc
export const filterAccountingCivjs = (
  civilJudgements: any,
  civjvmRequests: any,
  civjVehicles: any,
  judgementAddDocuments: any,
) => {
  const mechanicalExpertisesIds = civilJudgements
    .flatMap((item: any) => item.civjmece)
    .map((v: any) => v?.vehiculeId);
  const medicalExpertisesIds = [
    ...civilJudgements
      .flatMap((item: any) => item.civjmede)
      .map((v: any) => v?.victimId),
  ];
  const civjs = civilJudgements.map((civj: any) => {
    const filteredCivjacce = civj.civjacce.filter(
      (civjacce: any) =>
        !(
          (civjacce.victimId &&
            medicalExpertisesIds.includes(civjacce.victimId)) ||
          (civjacce.vehiculeId &&
            mechanicalExpertisesIds.includes(civjacce.vehiculeId))
        ),
    );
    return {
      ...civj,
      civjacce: filteredCivjacce,
    };
  });
  const civjvmRequest = isArray(civjvmRequests)
    ? civjvmRequests
    : Object.values(civjvmRequests).filter(item => item);
  const civjVehicle = isArray(civjVehicles)
    ? civjVehicles
    : Object.values(civjVehicles).filter(item => item);

  const allExpertiseJudgementAddDocumentIds = new Set([
    ...civjVehicle.map(
      (vehicle: any) => vehicle.expertiseJudgementAddDocumentId,
    ),
    ...civjvmRequest.map((vm: any) => vm.expertiseJudgementAddDocumentId),
    ...civjs.flatMap((civilJudgement: any) => {
      return [
        ...civilJudgement.civjacce.map(
          (acc: any) => acc.expertiseJudgementAddDocumentId,
        ),
        ...civilJudgement.civjmede.map(
          (mede: any) => mede.expertiseJudgementAddDocumentId,
        ),
        ...civilJudgement.civjmece.map(
          (mece: any) => mece.expertiseJudgmentAddDocumentId,
        ),
      ];
    }),
  ]);

  const filteredCivilJudgements = civilJudgements.filter(
    (civilJudgement: any) => {
      const { judgementAddDocumentId } = civilJudgement;

      const matchingJadd = judgementAddDocuments.find(
        (item: any) => item.id === judgementAddDocumentId,
      );

      if (!matchingJadd) {
        return true;
      }
      const isValid = matchingJadd.expertises.some((expertise: any) =>
        allExpertiseJudgementAddDocumentIds.has(
          expertise.expertiseJudgementAddDocumentId,
        ),
      );

      return isValid;
    },
  );
  return featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION)
    ? filteredCivilJudgements
    : civilJudgements;
};
export const filterAccountingCivilProceedings = (
  civilJudgement: any,
  medicalExpertisesIds: any,
  mechanicalExpertisesIds: any,
) => {
  return civilJudgement.filter((v: any) => {
    return featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION)
      ? !!v.victimId
        ? !medicalExpertisesIds.includes(v?.victimId)
        : !mechanicalExpertisesIds.includes(v?.vehiculeId)
      : true;
  });
};
export const getMedicalCivjvm = (
  civjvmRequest: any,
  judgementAddDocuments: any,
) => {
  return civjvmRequest
    .filter((civjvm: any) => {
      return judgementAddDocuments
        .flatMap((item: any) => item.expertises)
        .find((expertise: any) => {
          const victim =
            get(expertise, 'victims', []).find(
              (victim: VictimType) => victim.id === civjvm.victimId,
            ) || {};
          return (
            expertise.expertiseJudgementAddDocumentId ===
              civjvm.expertiseJudgementAddDocumentId &&
            String(expertise.expertiseId) === MEDICAL_EXPERTISE_ID &&
            !isEmpty(victim)
          );
        });
    })
    .map((item: any) => item?.victimId);
};

export const getMergedAccountingExpertise = (
  civilJudgements: any = [],
  civj: any,
) => {
  return (
    civilJudgements
      .flatMap((item: any) =>
        get(item, 'civjacce', []).map((civjacceItem: any) => ({
          ...civjacceItem,
          civilJudgementId: item.id,
        })),
      )
      .find((civjacceItem: any) => {
        const civjacceIncidentId = !!get(civjacceItem, 'victim', {})
          ? get(civjacceItem, 'victimId')
          : get(civjacceItem, 'vehiculeId');
        const civjIncidentId = !!get(civj, 'victim')
          ? get(civj, 'victimId')
          : get(civj, 'vehiculeId');
        return civjacceIncidentId === civjIncidentId;
      }) || {}
  );
};
const processExpertise = (
  allJudgementDocuments: any,
  expertises: any[],
  type: string,
) => {
  if (isEmpty(expertises)) return undefined;

  return expertises
    .map(expertise => {
      const formattedExpertise = formatCivjWithJudgementAddDocumentId(
        allJudgementDocuments,
        expertise,
      );
      return !isEmpty(formattedExpertise)
        ? {
            ...formattedExpertise,
            type,
          }
        : {};
    })
    .filter(item => !isEmpty(item));
};
export const formatExpertise = (
  judgementAddId: any,
  expertises: IExpertises,
  sharedResponsability: any,
) => {
  let medicalExpertise = isEmpty([...expertises.medicalExpertise])
    ? undefined
    : [...expertises.medicalExpertise];

  let accountingExpertise = isEmpty([...expertises.accountingExpertise])
    ? undefined
    : [...expertises.accountingExpertise];

  let mechanicalExpertise = isEmpty([...expertises.mechanicalExpertise])
    ? undefined
    : [...expertises.mechanicalExpertise];

  return {
    judgementAddDocumentId: judgementAddId,
    responsibilityShare: sharedResponsability,
    civjmede: medicalExpertise,
    civjacce: accountingExpertise,
    civjmece: mechanicalExpertise,
  };
};
export const formatExpertiseV2 = (
  judgementAddId: any,
  allJudgementDocuments: any,
  expertises: IExpertises,
  sharedResponsability: any,
) => {
  const formattedMedicalExpertise = processExpertise(
    allJudgementDocuments,
    expertises.medicalExpertise,
    'civjmede',
  );
  const formattedAccountingExpertise = processExpertise(
    allJudgementDocuments,
    expertises.accountingExpertise,
    'civjacce',
  );

  const formattedMechanicalExpertise = processExpertise(
    allJudgementDocuments,
    expertises.mechanicalExpertise,
    'civjmece',
  );

  const combinedExpertises = [
    ...(formattedMedicalExpertise || []),
    ...(formattedAccountingExpertise || []),
    ...(formattedMechanicalExpertise || []),
  ];

  const groupedByJudgementAddDocumentId = combinedExpertises.reduce(
    (acc, expertise) => {
      const { judgementAddDocumentId, type, ...rest } = expertise;

      if (!acc[judgementAddDocumentId]) {
        acc[judgementAddDocumentId] = {
          judgementAddDocumentId,
          responsibilityShare: sharedResponsability, // or dynamically calculate if needed
          civjmede: [],
          civjacce: [],
          civjmece: [],
        };
      }

      acc[judgementAddDocumentId][type].push(rest);
      return acc;
    },
    {},
  );
  return !isEmpty(groupedByJudgementAddDocumentId)
    ? Object.values(groupedByJudgementAddDocumentId).flat()
    : formatExpertise(judgementAddId, expertises, sharedResponsability);
};
export const getCurrentExpertiseForm = (
  expertiseType: any,
  modeType: string,
  expertises: any,
) =>
  expertiseType === EXPERTISES.ACCOUNTING_EXPERTISE &&
  modeType === MODE_TYPES.FORM
    ? expertises[EXPERTISES.ACCOUNTING_EXPERTISE]
    : expertiseType === EXPERTISES.MEDICAL_EXPERTISE &&
      modeType === MODE_TYPES.FORM
    ? expertises[EXPERTISES.MEDICAL_EXPERTISE]
    : expertiseType === EXPERTISES.MECHANICAL_EXPERTISE &&
      modeType === MODE_TYPES.FORM
    ? expertises[EXPERTISES.MECHANICAL_EXPERTISE]
    : [];
export const formatCivjWithJudgementAddDocumentId = (
  judgementDocuments: any,
  expertise: any,
) => {
  const matchingJadd = judgementDocuments.find((j: any) =>
    j.expertises.some(
      (expertiseDoc: any) =>
        expertiseDoc?.expertiseJudgementAddDocumentId ===
        get(
          expertise,
          'expertiseJudgementAddDocumentId',
          expertise?.expertiseJudgmentAddDocumentId,
        ),
    ),
  );
  if (!matchingJadd) {
    return {};
  }
  return {
    ...expertise,
    judgementAddDocumentId: matchingJadd ? matchingJadd.id : null,
  };
};
export const getMergedCivilJudgements = (
  civilJudgement: any = [],
  judgementOnMeritsRequest: any,
) =>
  _.isArray(civilJudgement)
    ? civilJudgement.map((current: any) => {
        const existingCivilJudgement = judgementOnMeritsRequest?.civjs.find(
          (civj: any) =>
            civj.judgementAddDocumentId === current.judgementAddDocumentId,
        );
        if (existingCivilJudgement) {
          ['civjmede', 'civjacce', 'civjmece'].forEach(type => {
            existingCivilJudgement[type] = [
              ...(existingCivilJudgement[type] || []),
              ...(current[type] || []),
            ];
          });
          return existingCivilJudgement;
        }

        return current;
      })
    : civilJudgement;
export const showAccountingBloc = (
  civilJudgement: any,
  accountingExpertises: any,
  medicalExpertisesIds: any,
  mechanicalExpertisesIds: any,
  judgementOnMeritsRequest: any,
  civjvmRequest: any,
) => {
  const usualCondition =
    !isEmpty(civilJudgement[CIVIL_JUDGEMENT_ACCOUNTING_EXPERTISE]) ||
    !isEmpty(accountingExpertises);
  return featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION)
    ? usualCondition &&
        (!isEmpty(
          filterAccountingCivilProceedings(
            civilJudgement[CIVIL_JUDGEMENT_ACCOUNTING_EXPERTISE].filter(
              (item: any) => item.id,
            ),
            medicalExpertisesIds,
            mechanicalExpertisesIds,
          ),
        ) ||
          !isEmpty(
            get(judgementOnMeritsRequest, 'civjVehicle', []).filter(
              (item: any) =>
                item?.id &&
                item?.expertiseJudgementAddDocumentId ===
                  get(
                    accountingExpertises,
                    'expertiseJudgementAddDocumentId',
                  ) &&
                !mechanicalExpertisesIds.includes(item?.vehicleId),
            ),
          ) ||
          !isEmpty(
            civjvmRequest.filter(
              (item: any) =>
                item?.id &&
                item?.expertiseJudgementAddDocumentId ===
                  get(
                    accountingExpertises,
                    'expertiseJudgementAddDocumentId',
                  ) &&
                !medicalExpertisesIds.includes(item?.victimId),
            ),
          ))
    : usualCondition;
};
export const resetCompensationBenficiary = (
  desceasedVictims: VictimType[],
  substrings: any,
) => {
  const victim = desceasedVictims.find(
    (victim: VictimType) => victim.id === Number(get(substrings, '[0]', 0)),
  ) as VictimType;
  const victimIndex = desceasedVictims.indexOf(victim);
  if (victimIndex !== -1) {
    const currentBeneficiary: any =
      desceasedVictims[victimIndex].beneficiaries[get(substrings, '[1]')];

    if (!isNil(currentBeneficiary) && currentBeneficiary !== -1) {
      currentBeneficiary.isDeletedCompensation = false;
      !!get(currentBeneficiary, 'beneficiaryWithoutCompensation.id')
        ? (currentBeneficiary.beneficiaryWithoutCompensation = {
            ...currentBeneficiary.beneficiaryWithoutCompensation,
            isDeleted: true,
          })
        : (currentBeneficiary.beneficiaryWithoutCompensation = {});
    }
  }
};
export const resetReasonNonCompensationBeneficiary = (
  desceasedVictims: any,
  substrings: any,
) => {
  const victim = desceasedVictims.find(
    (victim: VictimType) => victim.id === Number(get(substrings, '[0]', 0)),
  );
  const victimIndex = desceasedVictims.indexOf(victim);
  if (
    victimIndex !== -1 &&
    !isEmpty(get(desceasedVictims[victimIndex], 'beneficiaries', []))
  ) {
    const desceasedVictim = desceasedVictims[victimIndex];
    const beneficiaryIndex = get(substrings, '[1]');

    const currentBeneficiary =
      desceasedVictim.beneficiaries[get(substrings, '[1]')];
    if (!isNil(currentBeneficiary) && currentBeneficiary !== -1) {
      const { jomBwc, jomBeneficiaries, ...rest } = desceasedVictims[
        victimIndex
      ].beneficiaries[beneficiaryIndex];
      desceasedVictims[victimIndex].beneficiaries[beneficiaryIndex] = {
        ...rest,
        isDeletedCompensation: true,
      };
      !!get(currentBeneficiary, 'beneficiaryWithoutCompensation.id')
        ? (desceasedVictims[victimIndex].beneficiaries[
            beneficiaryIndex
          ].beneficiaryWithoutCompensation = {
            ...desceasedVictims[victimIndex].beneficiaries[beneficiaryIndex]
              .beneficiaryWithoutCompensation,
            reasonId: null,
            otherReason: null,
            isDeleted: false,
          })
        : (desceasedVictims[victimIndex].beneficiaries[
            beneficiaryIndex
          ].beneficiaryWithoutCompensation = {});
    }
  }
};
export const areBeneficiariesDataInvalid = (
  beneficiaries: any,
  civilJudgementVictimReason: Config[],
) => {
  return (
    !isEmpty(beneficiaries) &&
    !beneficiaries.every((item: any) => {
      return (
        (!isEmpty(get(item, 'beneficiaryWithoutCompensation', {})) &&
        !get(item, 'beneficiaryWithoutCompensation.isDeleted', false)
          ? !!get(item, 'beneficiaryWithoutCompensation.reasonId') &&
            (hasOtherReason(
              civilJudgementVictimReason,
              get(item, 'beneficiaryWithoutCompensation.reasonId'),
            )
              ? !isEmpty(
                  get(item, 'beneficiaryWithoutCompensation.otherReason', ''),
                )
              : true)
          : isNotEmpty(item?.judgementAmount) &&
            !get(item, 'isDeletedCompensation', false)) &&
        !isEmpty(item?.dateOfBirth) &&
        item?.dateOfBirth !== 'Invalid date'
      );
    })
  );
};
export const isNotEmpty = (value: any) => {
  return !isNil(value) && value !== '';
};

export const validateCivilJudgementsOnRecap = (
  judgementAddDocuments: any,
  allJudgementAddDocuments: any,
  judgement: any,
  civilJudgementOnMeritsFormMedicalExpertise: any[] = [],
  civilJudgementOnMeritsFormAccountingExpertise: any[] = [],
  civilJudgementOnMeritsFormMechanicalExpertise: any[] = [],
  civjvmRequest: any,
  civjVehicle: any,
  civilJudgementVictimReason: Config[],
  newCivjs: any[] = [],
  newCivjvm: any,
  isCJDisabled: any,
  judgementOnMerits: any,
) => {
  const medicalExpertise = [
    ...civilJudgementOnMeritsFormMedicalExpertise.flatMap((item: any) =>
      get(item, 'medExpertises', []),
    ),
    ...newCivjs.flatMap((item: any) => get(item, 'civjmede', [])),
  ].filter((item: any) => !get(item, 'isDeleted', false));
  const accountingExpertise = [
    ...civilJudgementOnMeritsFormAccountingExpertise.flatMap((item: any) =>
      get(item, 'accExpertises', []),
    ),
    ...newCivjs.flatMap((item: any) => get(item, 'civjacce', [])),
  ].filter((item: any) => !get(item, 'isDeleted', false));
  const mechanicalExpertise = [
    ...civilJudgementOnMeritsFormMechanicalExpertise.flatMap((item: any) =>
      get(item, 'mechanicalExpertise', []),
    ),
    ...newCivjs.flatMap((item: any) => get(item, 'civjmece', [])),
  ].filter((item: any) => !get(item, 'isDeleted', false));
  const expertises = {
    medicalExpertise,
    accountingExpertise,
    mechanicalExpertise,
  };
  const accountingExp = allJudgementAddDocuments
    .flatMap((item: any) => item.expertises)
    .filter((item: any) => String(item.expertiseId) === COMPTABLE_EXPERTISE_ID);

  const recentAccountingExpertises = accountingExp
    .flatMap((item: any) => get(item, 'victims', []))
    .sort(
      (a: any, b: any) =>
        new Date(get(a, 'createdAt')).getTime() -
        new Date(get(b, 'createdAt')).getTime(),
    );
  const recentAccountingVehiculesExpertises = accountingExp
    .flatMap((item: any) => get(item, 'vehicules', []))
    .sort(
      (a: any, b: any) =>
        new Date(get(a, 'createdAt')).getTime() -
        new Date(get(b, 'createdAt')).getTime(),
    );
  const civjvm = Object.values(newCivjvm).filter((item: any) => !isEmpty(item));
  const filtredJudgementAddDocuments = judgementAddDocuments.filter(
    (el: any) =>
      !isEmpty(
        get(el, 'expertises').filter(
          (item: any) =>
            new Date(item.createdAt) <
            new Date(get(judgementOnMerits, 'judgementOnMerits.createdAt')),
        ),
      ),
  );
  return (
    (!isEmpty(civjvm) || !isEmpty(newCivjs)
      ? Object.values(isCJDisabled).every(el => el)
      : true) &&
    filtredJudgementAddDocuments.every((judgementAddDocument: any) => {
      return validateCivilJudgement(
        get(judgementAddDocument, 'expertises', []),
        judgement,
        recentAccountingExpertises,
        recentAccountingVehiculesExpertises,
        expertises,
        [...civjvmRequest, ...civjvm],
        civjVehicle,
        civilJudgementVictimReason,
      );
    })
  );
};
export const validateCivilJudgement = (
  judgementAddDocExpertises: any,
  judgement: any,
  recentAccountingExpertises: any,
  recentAccountingVehiculesExpertises: any,
  expertises: any,
  civjvm: any,
  civjVehicle?: any,
  civilJudgementVictimReason?: Config[],
) => {
  return judgementAddDocExpertises.every((expertise: any) => {
    const {
      expertiseJudgementAddDocumentId,
      expertiseId,
      victims,
      vehicules,
    } = expertise;
    const hasValidVictims = victims
      .filter((item: any) => item?.injuryPostKey !== INJURY_POST_DECEASED)
      .every((victim: VictimType) => {
        const { id: victimId } = victim;
        const isVictimCivilJudgement = Object.keys(judgement).some(
          (key: any) => {
            const parts = key.split('-').map(Number);
            const [docId, expertiseType, incidentId] =
              parts.length === 3 ? parts : [parts[0], undefined, parts[1]];
            return (
              docId === expertiseJudgementAddDocumentId &&
              incidentId === victimId &&
              (expertiseType === undefined || expertiseType === expertiseId) &&
              (get(
                judgement[key],
                CIVIL_JUDGEMENT.VICTIM_CIVIL_JUDGEMENT,
                false,
              ) ||
                get(
                  judgement[key],
                  CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VICTIM_RECAP,
                  false,
                ))
            );
          },
        );
        const isReasonWithoutCompensation = Object.keys(judgement).some(
          (key: any) => {
            const parts = key.split('-').map(Number);
            const [docId, expertiseType, incidentId] =
              parts.length === 3 ? parts : [parts[0], undefined, parts[1]];
            return (
              docId === expertiseJudgementAddDocumentId &&
              incidentId === victimId &&
              (expertiseType === undefined || expertiseType === expertiseId) &&
              (get(judgement[key], CIVIL_JUDGEMENT.FORM_REJECTION, false) ||
                get(
                  judgement[key],
                  CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION,
                  false,
                ) ||
                get(
                  judgement[key],
                  CIVIL_JUDGEMENT.FORM_REJECTION_RECAP,
                  false,
                ) ||
                get(
                  judgement[key],
                  CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION_RECAP,
                  false,
                ))
            );
          },
        );
        if (isReasonWithoutCompensation) {
          const civjvmArray = Array.isArray(civjvm)
            ? civjvm
            : Object.values(civjvm);
          const victimData =
            civjvmArray.find(
              (item: any) =>
                item?.victimId === victimId &&
                item.expertiseJudgementAddDocumentId ===
                  expertiseJudgementAddDocumentId &&
                !get(item, 'isDeleted', false),
            ) || {};
          if (!isEmpty(victimData)) {
            return (
              isNotEmpty(
                get(victimData, CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON),
              ) &&
              (hasOtherReason(
                civilJudgementVictimReason,
                get(victimData, CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON),
              )
                ? !isEmpty(
                    get(
                      victimData,
                      CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON,
                      '',
                    ),
                  )
                : true)
            );
          }
        }
        if (isVictimCivilJudgement) {
          if (expertiseId === 1) {
            const hasAccouting = hasAccountingExpertise(
              recentAccountingExpertises,
              victim?.id,
            );
            const isMedicalValidated = get(
              expertises,
              'medicalExpertise',
              [],
            ).some(
              (item: any) =>
                item.expertiseJudgementAddDocumentId ===
                  expertiseJudgementAddDocumentId &&
                item.victimId === victimId &&
                isNotEmpty(item.compensationAmount) &&
                !get(item, 'isDeleted', false),
            );
            const isAccountingValidated = get(
              hasAccouting,
              'hasAccountingExpertise',
              false,
            )
              ? get(expertises, 'accountingExpertise', []).some(
                  (item: any) =>
                    item.expertiseJudgementAddDocumentId ===
                      get(
                        hasAccouting,
                        'accountingExpertise.expertiseJudgementAddDocumentId',
                      ) &&
                    item.victimId === victimId &&
                    isNotEmpty(item.evaluationAmount) &&
                    isNotEmpty(item.calculatedRevenue) &&
                    !get(item, 'isDeleted', false),
                )
              : true;
            return isMedicalValidated && isAccountingValidated;
          } else if (expertiseId === 2) {
            return get(expertises, 'accountingExpertise', []).some(
              (item: any) =>
                item.expertiseJudgementAddDocumentId ===
                  expertiseJudgementAddDocumentId &&
                item.victimId === victimId &&
                isNotEmpty(item.evaluationAmount) &&
                isNotEmpty(item.calculatedRevenue) &&
                !get(item, 'isDeleted', false),
            );
          }
        }
      });
    const hasValidVehicule = vehicules.every((vehicule: any) => {
      const { id: vehiculeId } = vehicule;
      const isVehiculeCivilJudgement = Object.keys(judgement)?.find(
        (key: any) => {
          const parts = key.split('-').map(Number);
          const [docId, expertiseType, incidentId] =
            parts.length === 3 ? parts : [parts[0], undefined, parts[1]];
          return (
            docId === expertiseJudgementAddDocumentId &&
            incidentId === vehiculeId &&
            (expertiseType === undefined || expertiseType === expertiseId) &&
            (get(
              judgement[key],
              CIVIL_JUDGEMENT.VEHICLE_CIVIL_JUDGEMENT,
              false,
            ) ||
              get(
                judgement[key],
                CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VEHICLE_RECAP,
                false,
              ))
          );
        },
      );
      if (isVehiculeCivilJudgement) {
        if (expertiseId === 3) {
          const hasAccouting = hasAccountingExpertise(
            recentAccountingVehiculesExpertises,
            vehiculeId,
          );

          const isMechanicalValidated = get(
            expertises,
            'mechanicalExpertise',
            [],
          ).some(
            (item: any) =>
              item.expertiseJudgmentAddDocumentId ===
                expertiseJudgementAddDocumentId &&
              item.vehiculeId === vehiculeId &&
              isNotEmpty(item?.damageAmount) &&
              !get(item, 'isDeleted', false),
          );
          const isAccountingValidated = get(
            hasAccouting,
            'hasAccountingExpertise',
            false,
          )
            ? get(expertises, 'accountingExpertise', []).some(
                (item: any) =>
                  item.expertiseJudgementAddDocumentId ===
                    get(
                      hasAccouting,
                      'accountingExpertise.expertiseJudgementAddDocumentId',
                    ) &&
                  item.vehiculeId === vehiculeId &&
                  isNotEmpty(item.evaluationAmount) &&
                  !get(item, 'isDeleted', false),
              )
            : true;
          return isMechanicalValidated && isAccountingValidated;
        } else if (expertiseId === 2) {
          return get(expertises, 'accountingExpertise', []).some(
            (item: any) =>
              item.expertiseJudgementAddDocumentId ===
                expertiseJudgementAddDocumentId &&
              item.vehiculeId === vehiculeId &&
              isNotEmpty(item?.evaluationAmount) &&
              !get(item, 'isDeleted', false),
          );
        }
      }
      const isReasonWithoutCompensation = Object.keys(judgement).find(
        (key: any) => {
          const parts = key.split('-').map(Number);
          const [docId, expertiseType, incidentId] =
            parts.length === 3 ? parts : [parts[0], undefined, parts[1]];
          return (
            docId === expertiseJudgementAddDocumentId &&
            incidentId === vehiculeId &&
            (expertiseType === undefined || expertiseType === expertiseId) &&
            (get(judgement[key], CIVIL_JUDGEMENT.FORM_REJECTION, false) ||
              get(
                judgement[key],
                CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION,
                false,
              ) ||
              get(
                judgement[key],
                CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION_RECAP,
                false,
              ) ||
              get(judgement[key], CIVIL_JUDGEMENT.FORM_REJECTION_RECAP, false))
          );
        },
      );
      if (isReasonWithoutCompensation) {
        const civjVehicleArray = Array.isArray(civjVehicle)
          ? civjVehicle
          : Object.values(civjVehicle);

        const vehicleData =
          civjVehicleArray.find((item: any) => {
            return (
              item?.vehicleId === vehiculeId &&
              item.expertiseJudgementAddDocumentId ===
                expertiseJudgementAddDocumentId &&
              !get(item, 'isDeleted', false)
            );
          }) || {};
        if (!isEmpty(vehicleData)) {
          return (
            isNotEmpty(
              get(vehicleData, CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON),
            ) &&
            (hasOtherReason(
              civilJudgementVictimReason,
              get(vehicleData, CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON),
            )
              ? !isEmpty(
                  get(
                    vehicleData,
                    CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON,
                    '',
                  ),
                )
              : true)
          );
        }
      }
    });

    return (
      (!isEmpty(victims) ? hasValidVictims : true) &&
      (!isEmpty(vehicules) ? hasValidVehicule : true)
    );
  });
};
export const shouldValidateDesceasedVictims = (
  desceasedVictims: VictimType[],
  civilJudgementVictimReason: Config[],
  jmv: any,
  props: any,
) => {
  return !isEmpty(desceasedVictims)
    ? desceasedVictims.every((victim: VictimType) => {
        const errors = shouldValidateDesceasedVictim(
          victim,
          civilJudgementVictimReason,
          jmv,
          props,
        );

        return (
          isEmpty(get(errors, 'alertErrors', {})) &&
          isEmpty(get(errors, 'requiredErrors', {}))
        );
      })
    : true;
};
const resolveLawyerCompensationAmount = (
  el: any,
  desceasedVictims: any,
  judgementOnMeritsRequest: any,
  listings: any,
) => {
  const civj = getCivilJudgementByVictimId(
    get(judgementOnMeritsRequest, 'civjs', []),
    el,
  );
  let deceasedVictim = null;
  let victim = null;
  if (el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2') {
    const jmv =
      get(judgementOnMeritsRequest, 'jmv', []).find(
        (item: JudgementOnMeritsVictim) => item.victimId === el.victimId,
      ) || {};
    deceasedVictim =
      desceasedVictims.find((item: any) => item.victimId === el.victimId) || {};
    return isNextOfKinsSubstantive(
      get(deceasedVictim, 'beneficiaries', []),
      get(listings, 'civilJudgementVictimReason', []),
    )
      ? 0
      : !isNil(get(jmv, 'compensationAmount', null))
      ? Number(get(jmv, 'compensationAmount', null))
      : Number(get(deceasedVictim, 'judiciaryAmount'));
  }
  if (el.expertiseId === 1) {
    const victim = civj.find(cj => !isEmpty(cj.civjmede));
    return get(victim, 'civjmede[0].compensationAmount', '');
  }

  victim = civj.find(cj => !isEmpty(cj.civjacce));
  return get(victim, 'civjacce[0].calculatedRevenue', '');
};

const resolveRevenu = (el: any, judgementOnMeritsRequest: any) => {
  const civj = getCivilJudgementByVictimId(
    get(judgementOnMeritsRequest, 'civjs', []),
    el,
  );
  if (el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2')
    return el[VICTIM_EXPERTISE_FIELDS.FIXED_ANNUAL_INCOME];
  if (el.expertiseId === 2) {
    const victim = civj.find(civj => !isEmpty(civj.civjacce));
    return get(victim, 'civjacce[0].evaluationAmount', el?.fixedAnnualIncome);
  }
};

export const mapSagisEvaluation = (
  victimExpertises: any,
  desceasedVictim: VictimType[],
  isMultiple: boolean,
  judgement: any,
  judgementOnMeritsRequest: any,
  expertiseReport: any,
  civilJudgementOnMeritsForm: any,
  judgementOnMeritsInfo: any,
  civilProceedingVictims: any,
  civilJudgementVictimReasonListing: any,
  jomAssociatedVictims: any,
  listings: any,
  victims: any,
  judiciaryProcessId: any,
  claim: any,
  dahirAmount?: any,
) => {
  return victimExpertises
    .filter((vi: any) => {
      const victim =
        desceasedVictim.find((item: any) => item?.victimId === vi?.victimId) ||
        (({} as unknown) as VictimType);
      return (
        !vi.isOld &&
        isJomAssociatedVictimsIncluded(
          isMultiple,
          vi[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
          jomAssociatedVictims,
        ) &&
        reasonWithoutCompensationConditions(
          vi,
          judgement,
          Object.values(get(judgementOnMeritsRequest, 'civjvm', {})).filter(
            (item: any) => !isEmpty(item),
          ),
          victim,
          civilJudgementVictimReasonListing,
        )
      );
    })
    .map((el: any) => {
      const lastMedicalExpertise =
        get(expertiseReport, 'victimExpertises', []).find(
          (item: any) =>
            String(item?.victimId) === String(el?.victimId) &&
            !item.isOld &&
            item.status !== GLOBAL_STATUS.PENDING &&
            item.status !== GLOBAL_STATUS.REJECTED &&
            !item.isRejectedJudgement &&
            String(item.expertiseId) === MEDICAL_EXPERTISE_ID,
        ) || {};
      const lastEvaluation = getTheLatestEvaluationObject(
        getVictimKey(
          el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
          civilProceedingVictims || (([] as unknown) as VictimType[]),
        ),
        dahirAmount,
      );
      const objectToReturn = featureService.hasFeature(
        FEATURES.RESOLVE_EXPERTISE_REPORT_VALUES,
      )
        ? {
            gestionMode: '',
            materialAmount: '',
            currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
            judiciaryAmount: isCivilJudgementVictimSubstantive(
              civilJudgementVictimReasonListing,
              el,
              Object.values(get(judgementOnMeritsRequest, 'civjvm', {})).filter(
                (item: any) => !isEmpty(item),
              ),
            )
              ? 0
              : resolveLawyerCompensationAmount(
                  el,
                  desceasedVictim,
                  judgementOnMeritsRequest,
                  listings,
                ),
            responsibilityRate: getResponsabilityShare(
              get(judgementOnMeritsRequest, 'civjs', []),
              el,
              desceasedVictim,
              expertiseReport.victimExpertises,
              civilJudgementOnMeritsForm,
              get(
                judgementOnMeritsRequest,
                '[civjs][0][responsibilityShare]',
                null,
              ),
            ),
            rateRecovery: resolveExpertiseValue(
              el,
              el[VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL],
              lastMedicalExpertise,
              lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL],
              get(lastEvaluation, 'rateRecovery'),
            ),
            revenu: !isNil(
              getVictimRevenu(
                el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                victims,
                judiciaryProcessId,
              ),
            )
              ? getVictimRevenu(
                  el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                  victims,
                  judiciaryProcessId,
                )
              : el.expertiseId === 1
              ? el[VICTIM_EXPERTISE_FIELDS.VICTIM_REVENUE]
              : resolveRevenu(el, judgementOnMeritsRequest),
            age: getVictimAge(
              el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
              victims,
              get(claim, 'lossDate', ''),
            ),
            mode:
              el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                ? MODE.DECEASED
                : MODE.BLESSE,
            ratePretium: resolveExpertiseValue(
              el,
              el[VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS],
              lastMedicalExpertise,
              lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS],
              get(lastEvaluation, 'ratePretium'),
            ),
            lossDate: moment(get(claim, 'lossDate', '')).toISOString(true),
            rateAestheticDamageWithoutConsequence: resolveExpertiseValue(
              el,
              el[VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE],
              lastMedicalExpertise,
              lastMedicalExpertise[
                VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE
              ],
              get(lastEvaluation, 'rateAestheticDamageWithoutConsequence'),
            ),
            rateAestheticDamageWithConsequence: resolveExpertiseValue(
              el,
              el[VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITH_CONSEQUENCE],
              lastMedicalExpertise,
              lastMedicalExpertise[
                VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITH_CONSEQUENCE
              ],
              get(lastEvaluation, 'rateAestheticDamageWithConsequence'),
            ),
            rateCareerPrejudice: resolveExpertiseValue(
              el,
              el[VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE],
              lastMedicalExpertise,
              lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE],
              get(lastEvaluation, 'rateCareerPrejudice'),
            ),
            rateSchoolingPrejudice: resolveExpertiseValue(
              el,
              el[VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE],
              lastMedicalExpertise,
              lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE],
              get(lastEvaluation, 'rateSchoolingPrejudice'),
            ),
            rateIPP: resolveExpertiseValue(
              el,
              el[VICTIM_EXPERTISE_FIELDS.IPP],
              lastMedicalExpertise,
              lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.IPP],
              get(lastEvaluation, 'rateIPP'),
            ),
            rateITT: getRateItt(el, lastMedicalExpertise, lastEvaluation),
            victimKey: getVictimKey(
              el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
              victims,
            ),
            medicalPharmaceuticalFees:
              el[VICTIM_EXPERTISE_FIELDS.MEDICAL_PHARMACEUTICAL_FEES],
            // rateMedicalPharmaceuticalFees: '',
            transactionPhase: 1,
            isJusticeFeesChecked:
              get(judgementOnMeritsInfo, 'responsibility', '') === 'Oui'
                ? true
                : false,
            isIDDChecked:
              get(judgementOnMeritsInfo, 'idd', '') === 'Oui' ? true : false,
            iddEffectiveDate: get(
              judgementOnMeritsInfo,
              'calculationStartDate',
            ),
            JudiciartDecisionDate: get(
              judgementOnMeritsInfo,
              'judgementDate',
              '',
            ),
            expType: Number(el.expertiseId),
            isRecentExpertiseVictim: el.isRecentExpertiseVictim,
            funeralFeesAmount:
              el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                ? get(
                    resolveDeceasedVictimFees(
                      el,
                      el?.victimId,
                      get(judgementOnMeritsRequest, 'jmv', []),
                    ),
                    'funeralFees',
                    null,
                  )
                : undefined,
            medicalFeesAmount:
              el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                ? get(
                    resolveDeceasedVictimFees(
                      el,
                      el?.victimId,
                      get(judgementOnMeritsRequest, 'jmv', []),
                    ),
                    'medicalFees',
                    null,
                  )
                : undefined,
          }
        : {
            gestionMode: '',
            materialAmount: '',
            currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
            judiciaryAmount: isCivilJudgementVictimSubstantive(
              civilJudgementVictimReasonListing,
              el,
              Object.values(get(judgementOnMeritsRequest, 'civjvm', {})).filter(
                (item: any) => !isEmpty(item),
              ),
            )
              ? 0
              : resolveLawyerCompensationAmount(
                  el,
                  desceasedVictim,
                  judgementOnMeritsRequest,
                  listings,
                ),
            responsibilityRate: getResponsabilityShare(
              get(judgementOnMeritsRequest, 'civjs', []),
              el,
              desceasedVictim,
              expertiseReport.victimExpertises,
              civilJudgementOnMeritsForm,
              get(
                judgementOnMeritsRequest,
                '[civjs][0][responsibilityShare]',
                null,
              ),
            ),
            rateRecovery: el[VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL],
            revenu: !isNil(
              getVictimRevenu(
                el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                victims,
                judiciaryProcessId,
              ),
            )
              ? getVictimRevenu(
                  el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                  victims,
                  judiciaryProcessId,
                )
              : el.expertiseId === 1
              ? el[VICTIM_EXPERTISE_FIELDS.VICTIM_REVENUE]
              : resolveRevenu(el, judgementOnMeritsRequest),
            age: getVictimAge(
              el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
              victims,
              get(claim, 'lossDate', ''),
            ),
            lossDate: moment(get(claim, 'lossDate', '')).toISOString(true),
            mode:
              el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                ? MODE.DECEASED
                : MODE.BLESSE,
            ratePretium: el[VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS],
            rateAestheticDamageWithoutConsequence:
              el[VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE],
            rateAestheticDamageWithConsequence:
              el[VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITH_CONSEQUENCE],
            rateCareerPrejudice: el[VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE],
            rateSchoolingPrejudice:
              el[VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE],
            rateIPP: el[VICTIM_EXPERTISE_FIELDS.IPP],
            rateITT: el[VICTIM_EXPERTISE_FIELDS.ITT]
              ? el[VICTIM_EXPERTISE_FIELDS.ITT]
              : el.previousItt,
            victimKey: getVictimKey(
              el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
              victims,
            ),
            medicalPharmaceuticalFees:
              el[VICTIM_EXPERTISE_FIELDS.MEDICAL_PHARMACEUTICAL_FEES],
            rateMedicalPharmaceuticalFees: '',
            transactionPhase: 1,
            isJusticeFeesChecked:
              get(judgementOnMeritsInfo, 'responsibility', '') === 'Oui'
                ? true
                : false,
            isIDDChecked:
              get(judgementOnMeritsInfo, 'idd', '') === 'Oui' ? true : false,
            iddEffectiveDate: get(
              judgementOnMeritsInfo,
              'calculationStartDate',
            ),
            JudiciartDecisionDate: get(
              judgementOnMeritsInfo,
              'judgementDate',
              '',
            ),
            expType: Number(el.expertiseId),
            isRecentExpertiseVictim: el.isRecentExpertiseVictim,
            funeralFeesAmount:
              el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                ? get(
                    resolveDeceasedVictimFees(
                      el,
                      el?.victimId,
                      get(judgementOnMeritsRequest, 'jmv', []),
                    ),
                    'funeralFees',
                    null,
                  )
                : undefined,
            medicalFeesAmount:
              el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                ? get(
                    resolveDeceasedVictimFees(
                      el,
                      el?.victimId,
                      get(judgementOnMeritsRequest, 'jmv', []),
                    ),
                    'medicalFees',
                    null,
                  )
                : undefined,
          };
      return (
        checkVictimExistanceCivilPartyById(
          el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
          civilProceedingVictims,
        ).includes(true) && objectToReturn
      );
    });
};

export const mapCivilDocumentsEvaluations = (
  desceasedVictim: VictimType[],
  judgementAddClone: any,
  beneficiaries: any,
  sagisEvalVictimKeys: any,
  isMultiple: any,
  judgementOnMeritsRequest: any,
  judgementOnMeritsInfo: any,
  civilProceedingVictims: any,
  civilJudgementVictimReasonListing: any,
  jomAssociatedVictims: any,
  victims: VictimType[],
  judiciaryProcessId: any,
  claim: any,
) => {
  return checkVictimExistanceCivilParty(
    desceasedVictim,
    civilProceedingVictims,
  ) &&
    checkVictimExistanceCivilParty(
      desceasedVictim,
      civilProceedingVictims,
    ).includes(true)
    ? get(judgementAddClone, 'civilDocuments', []).flatMap((el: any) => {
        return get(el, 'victims', [])
          .filter((v: any) => {
            const victimBeneficiaries = beneficiaries.filter(
              (beneficiary: any) =>
                beneficiary?.victimId === get(v, 'victimId', v?.id),
            );
            return (
              v[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2' &&
              !sagisEvalVictimKeys.includes(v.victimKey) &&
              isJomAssociatedVictimsIncluded(
                isMultiple,
                get(v, 'victimId', v?.id),
                jomAssociatedVictims,
              ) &&
              !isNextOfKinsWithFormRejection(
                victimBeneficiaries,
                civilJudgementVictimReasonListing,
              )
            );
          })
          .map((victim: VictimType) => {
            const currentVictim = desceasedVictim.find(
              (el: any) => el.victimId === victim.id,
            );
            const jmv =
              get(judgementOnMeritsRequest, 'jmv', []).find(
                (item: JudgementOnMeritsVictim) =>
                  item.victimId === get(victim, 'victimId', victim?.id),
              ) || {};
            return {
              judiciaryAmount: isNextOfKinsSubstantive(
                get(currentVictim, 'beneficiaries', []),
                civilJudgementVictimReasonListing,
              )
                ? 0
                : !isNil(get(jmv, 'compensationAmount', null))
                ? Number(get(jmv, 'compensationAmount'))
                : get(currentVictim, 'judiciaryAmount', ''),
              gestionMode: '',
              materialAmount: '',
              currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
              responsibilityRate: victim['responsibilityShare'],
              rateRecovery: null,
              revenu: !isNil(
                getVictimRevenu(victim.id, victims, judiciaryProcessId),
              )
                ? getVictimRevenu(victim.id, victims, judiciaryProcessId)
                : victim['annualOfIncome'],
              age: getVictimAge(
                get(victim, 'victimId', victim?.id),
                victims,
                get(claim, 'lossDate', ''),
              ),
              mode: MODE.DECEASED,
              lossDate: moment(get(claim, 'lossDate', '')).toISOString(true),
              funeralFeesAmount: get(jmv, 'funeralFees', null),
              medicalFeesAmount: get(jmv, 'medicalFees', null),
              ratePretium: null,
              rateAestheticDamageWithoutConsequence: null,
              rateAestheticDamageWithConsequence: null,
              rateCareerPrejudice: null,
              rateSchoolingPrejudice: null,
              rateIPP: null,
              rateITT: null,
              victimKey: victim['victimKey'],
              medicalPharmaceuticalFees: null,
              rateMedicalPharmaceuticalFees: '',
              transactionPhase: 1,
              isJusticeFeesChecked:
                get(judgementOnMeritsInfo, 'responsibility', '') === 'Oui'
                  ? true
                  : false,
              isIDDChecked:
                get(judgementOnMeritsInfo, 'idd', '') === 'Oui' ? true : false,
              iddEffectiveDate: get(
                judgementOnMeritsInfo,
                'calculationStartDate',
              ),
              JudiciartDecisionDate: get(
                judgementOnMeritsInfo,
                'judgementDate',
                '',
              ),
            };
          });
      })
    : [];
};

export const mapJudiciaryProcessEvaluations = (
  expertises: any,
  beneficiaries: any,
  sagisEvalVictimKeys: any,
  civilDocumentsVictimKeys: any,
  isMultiple: any,
  desceasedVictim: VictimType[],
  judgementOnMeritsRequest: any,
  judgementOnMeritsInfo: any,
  civilProceedingVictims: any,
  civilJudgementVictimReasonListing: any,
  jomAssociatedVictims: any,
  victims: VictimType[],
  judiciaryProcessId: any,
  claim: any,
) => {
  return expertises
    .filter((v: any) => {
      const victimBeneficiaries = beneficiaries.filter(
        (beneficiary: any) => beneficiary?.victimId === v?.id,
      );
      return (
        v[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2' &&
        !sagisEvalVictimKeys.includes(v.victimKey) &&
        !civilDocumentsVictimKeys.includes(v.victimKey) &&
        isJomAssociatedVictimsIncluded(
          isMultiple,
          get(v, 'id'),
          jomAssociatedVictims,
        ) &&
        !isNextOfKinsWithFormRejection(
          victimBeneficiaries,
          civilJudgementVictimReasonListing,
        )
      );
    })
    .map((victim: VictimType) => {
      const currentVictim = desceasedVictim.find(
        (el: any) => el.victimId === victim.id,
      );
      const jmv =
        get(judgementOnMeritsRequest, 'jmv', []).find(
          (item: JudgementOnMeritsVictim) =>
            item.victimId === get(victim, 'victimId', victim?.id),
        ) || {};
      return (
        checkVictimExistanceCivilPartyById(
          (victim['id'] as unknown) as number,
          civilProceedingVictims,
        ).includes(true) && {
          gestionMode: '',
          materialAmount: '',
          currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
          judiciaryAmount: isNextOfKinsSubstantive(
            get(currentVictim, 'beneficiaries', []),
            civilJudgementVictimReasonListing,
          )
            ? 0
            : !isNil(get(jmv, 'compensationAmount', null))
            ? Number(get(jmv, 'compensationAmount'))
            : get(currentVictim, 'judiciaryAmount', ''),
          responsibilityRate: get(currentVictim, 'responsibilityShare', ''),
          rateRecovery: null,
          revenu: !isNil(
            getVictimRevenu(victim['id'], victims, judiciaryProcessId),
          )
            ? getVictimRevenu(victim['id'], victims, judiciaryProcessId)
            : victim['annualOfIncome'],
          age: getVictimAge(victim['id'], victims, get(claim, 'lossDate', '')),
          mode: MODE.DECEASED,
          lossDate: moment(get(claim, 'lossDate', '')).toISOString(true),
          funeralFeesAmount: get(jmv, 'funeralFees', null),
          medicalFeesAmount: get(jmv, 'medicalFees', null),
          ratePretium: null,
          rateAestheticDamageWithoutConsequence: null,
          rateAestheticDamageWithConsequence: null,
          rateCareerPrejudice: null,
          rateSchoolingPrejudice: null,
          rateIPP: null,
          rateITT: null,
          victimKey: victim['victimKey'],
          medicalPharmaceuticalFees: null,
          rateMedicalPharmaceuticalFees: '',
          transactionPhase: 1,
          isJusticeFeesChecked:
            get(judgementOnMeritsInfo, 'responsibility', '') === 'Oui'
              ? true
              : false,
          isIDDChecked:
            get(judgementOnMeritsInfo, 'idd', '') === 'Oui' ? true : false,
          iddEffectiveDate: get(judgementOnMeritsInfo, 'calculationStartDate'),
          JudiciartDecisionDate: get(
            judgementOnMeritsInfo,
            'judgementDate',
            '',
          ),
        }
      );
    });
};

const formatEvaluations = (
  victimIds: any,
  judgementOnMerits: any,
  judgementOnMeritsRequest: any,
  victims: any,
) => {
  return victimIds.map((id: number) => {
    let judiciaryAmount = null;
    let revenu = null;
    let itt = null;
    let expertiseJudgementAddDocumentId = null;
    let expertiseId = null;
    get(judgementOnMeritsRequest, 'civjs', []).forEach((el: any) => {
      let found = get(el, 'civjmede', []).find((el: any) => el.victimId === id);
      if (found) {
        judiciaryAmount = get(found, 'compensationAmount');
        expertiseJudgementAddDocumentId = get(
          found,
          'expertiseJudgementAddDocumentId',
        );
        expertiseId = EXPERTISE_MEDICAL_ID;
        itt = get(
          victims.find((v: any) => v.id === id),
          'itt',
        );
      } else {
        found = get(el, 'civjacce', []).find((el: any) => el.victimId === id);
        if (found) {
          judiciaryAmount = get(found, 'calculatedRevenue');
          expertiseJudgementAddDocumentId = get(
            found,
            'expertiseJudgementAddDocumentId',
          );
          expertiseId = EXPERTISE_ACCOUNTING_ID;

          itt = get(
            victims.find((v: any) => v.id === id),
            'itt',
          );
        }
      }
    });
    get(judgementOnMeritsRequest, 'civjs', []).forEach((el: any) => {
      let found = get(el, 'civjacce', []).find((el: any) => el.victimId === id);
      if (found) {
        revenu = get(found, 'evaluationAmount');
        expertiseJudgementAddDocumentId = get(
          found,
          'expertiseJudgementAddDocumentId',
        );
        expertiseId = EXPERTISE_ACCOUNTING_ID;
      }
    });
    Object.values(get(judgementOnMeritsRequest, 'civjvm', {})).forEach(
      (el: any) => {
        if (el?.victimId === id) {
          expertiseJudgementAddDocumentId = get(
            el,
            'expertiseJudgementAddDocumentId',
          );
        }
      },
    );
    return {
      victimId: id,
      judiciaryAmount,
      responsibilityShare: get(
        judgementOnMerits,
        'judgementOnMerits.jom.civjs[0].responsibilityShare',
        null,
      ),
      revenu,
      itt,
      expertiseJudgementAddDocumentId,
      expertiseId,
    };
  });
};

export const mapSagisEvaluationsWithoutExpertise = (
  judgementAddDocuments: any,
  expertiseReport: any,
  judgementOnMerits: any,
  judgementOnMeritsRequest: any,
  sharedResponsability: any,
  judgement: any,
  judgementOnMeritsInfo: any,
  civilProceedingVictims: any,
  civilJudgementVictimReasonListing: any,
  victims: any,
  judiciaryProcessId: any,
  claim: any,
  dahirAmount?: any,
) => {
  return formatEvaluations(
    difference(
      [
        ...uniq(getVictimIds(judgementAddDocuments)).filter(
          (id: any) =>
            ![
              ...victims
                .filter((v: any) => v.injuryPostKey === INJURY_POST_DECEASED)
                .map((v: any) => v.id),
            ].includes(id),
        ),
      ],
      get(expertiseReport, 'victimExpertises', []).map(
        (el: any) => el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
      ),
    ),
    judgementOnMerits,
    judgementOnMeritsRequest,
    victims,
  )
    .filter((item: any) => {
      return reasonWithoutCompensationConditions(
        item,
        judgement,
        Object.values(get(judgementOnMeritsRequest, 'civjvm', {})).filter(
          (item: any) => !isEmpty(item),
        ),
        ([] as unknown) as VictimType,
        civilJudgementVictimReasonListing,
      );
    })
    .map((el: any) => {
      const lastEvaluation = getTheLatestEvaluationObject(
        getVictimKey(
          el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
          civilProceedingVictims || (([] as unknown) as VictimType[]),
        ),
        dahirAmount,
      );
      return (
        checkVictimExistanceCivilPartyById(
          el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
          civilProceedingVictims,
        ).includes(true) && {
          gestionMode: '',
          materialAmount: '',
          currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
          judiciaryAmount: isCivilJudgementVictimSubstantive(
            civilJudgementVictimReasonListing,
            el,
            Object.values(get(judgementOnMeritsRequest, 'civjvm', {})).filter(
              (item: any) => !isEmpty(item),
            ),
          )
            ? 0
            : el['judiciaryAmount'],
          responsibilityRate: sharedResponsability,
          revenu: !isNil(
            getVictimRevenu(
              el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
              victims,
              judiciaryProcessId,
            ),
          )
            ? getVictimRevenu(
                el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                victims,
                judiciaryProcessId,
              )
            : el['revenu'],
          age: getVictimAge(
            el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
            victims,
            get(claim, 'lossDate', ''),
          ),
          mode: MODE.BLESSE,
          lossDate: moment(get(claim, 'lossDate', '')).toISOString(true),
          rateITT: featureService.hasFeature(
            FEATURES.RESOLVE_EXPERTISE_REPORT_VALUES,
          )
            ? el[VICTIM_EXPERTISE_FIELDS.ITT]
              ? el[VICTIM_EXPERTISE_FIELDS.ITT]
              : String(get(lastEvaluation, 'rateITT'))
            : el[VICTIM_EXPERTISE_FIELDS.ITT],
          victimKey: getVictimKey(
            el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
            victims,
          ),
          rateMedicalPharmaceuticalFees: '',
          transactionPhase: 1,
          isJusticeFeesChecked:
            get(judgementOnMeritsInfo, 'responsibility', '') === 'Oui'
              ? true
              : false,
          isIDDChecked:
            get(judgementOnMeritsInfo, 'idd', '') === 'Oui' ? true : false,
          iddEffectiveDate: get(judgementOnMeritsInfo, 'calculationStartDate'),
          JudiciartDecisionDate: get(
            judgementOnMeritsInfo,
            'judgementDate',
            '',
          ),
          isRecentExpertiseVictim: el.isRecentExpertiseVictim,
        }
      );
    });
};
export const mapReasonWithoutCompensationEvaluations = (
  judgementOnMeritsRequest: any,
  sharedResponsability: any,
  judgementOnMeritsInfo: any,
  civilProceedingVictims: any,
  civilJudgementVictimReasonListing: any,
  victims: any,
  claim: any,
  judiciaryProcessId: any,
  expertiseReport: any,
  dahirAmount?: any,
) => {
  return getSubstantiveWithoutCompensation(
    civilJudgementVictimReasonListing,
    Object.values(get(judgementOnMeritsRequest, 'civjvm', {})).filter(
      (item: any) => !isEmpty(item),
    ),
  ).map((item: any) => {
    const lastMedicalExpertise =
      get(expertiseReport, 'victimExpertises', []).find(
        (el: any) =>
          String(el?.victimId) === String(item?.victimId) &&
          !el.isOld &&
          el.status !== GLOBAL_STATUS.PENDING &&
          el.status !== GLOBAL_STATUS.REJECTED &&
          !el.isRejectedJudgement &&
          String(el.expertiseId) === MEDICAL_EXPERTISE_ID,
      ) || {};
    const lastEvaluation = getTheLatestEvaluationObject(
      getVictimKey(
        item[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
        civilProceedingVictims || (([] as unknown) as VictimType[]),
      ),
      dahirAmount,
    );
    const victim =
      civilProceedingVictims.find(
        (victim: VictimType) => victim?.id === get(item, 'victimId'),
      ) || {};
    return (
      checkVictimExistanceCivilPartyById(
        item[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
        civilProceedingVictims,
      ).includes(true) && {
        gestionMode: '',
        materialAmount: '',
        currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
        judiciaryAmount: 0,
        responsibilityRate: sharedResponsability,
        age: getVictimAge(
          item[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
          victims,
          get(claim, 'lossDate', ''),
        ),
        mode: MODE.BLESSE,
        lossDate: moment(get(claim, 'lossDate', '')).toISOString(true),
        rateITT: featureService.hasFeature(
          FEATURES.RESOLVE_EXPERTISE_REPORT_VALUES,
        )
          ? resolveExpertiseValue(
              item,
              get(item, [VICTIM_EXPERTISE_FIELDS.ITT]),
              lastMedicalExpertise,
              lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.ITT],
              get(lastEvaluation, 'rateITT'),
            )
          : get(victim, [VICTIM_EXPERTISE_FIELDS.ITT]),
        victimKey: getVictimKey(
          item[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
          victims,
        ),
        revenu: getVictimRevenu(
          item[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
          victims,
          judiciaryProcessId,
        ),
        rateMedicalPharmaceuticalFees: '',
        transactionPhase: 1,
        isJusticeFeesChecked:
          get(judgementOnMeritsInfo, 'responsibility', '') === 'Oui'
            ? true
            : false,
        isIDDChecked:
          get(judgementOnMeritsInfo, 'idd', '') === 'Oui' ? true : false,
        iddEffectiveDate: get(judgementOnMeritsInfo, 'calculationStartDate'),
        JudiciartDecisionDate: get(judgementOnMeritsInfo, 'judgementDate', ''),
      }
    );
  });
};
